/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * * `new` - New
 * * `working` - Working
 * * `finished` - Finished
 */
export enum WorkdayStatusEnum {
    New = 'new',
    Working = 'working',
    Finished = 'finished'
}

/**
 * * `in` - Clock In
 * * `out` - Clock Out
 */
export enum WorkEventKindEnum {
    In = 'in',
    Out = 'out'
}

/**
 * * `accrual` - Accrual
 * * `carry_over` - Carry over
 * * `usage` - Usage
 * * `usage_revert` - Usage revert
 * * `manual_adjustment` - Manual adjustment
 */
export enum TransactionTypeEnum {
    Accrual = 'accrual',
    CarryOver = 'carry_over',
    Usage = 'usage',
    UsageRevert = 'usage_revert',
    ManualAdjustment = 'manual_adjustment'
}

/**
 * * `vacation_request` - Vacation request
 * * `annual_accrual` - Annual accrual
 * * `annual_carry_over` - Annual carry over
 * * `manual` - Manual
 */
export enum SourceTypeEnum {
    VacationRequest = 'vacation_request',
    AnnualAccrual = 'annual_accrual',
    AnnualCarryOver = 'annual_carry_over',
    Manual = 'manual'
}

/**
 * * `adjustment` - Schedule adjustment
 * * `shift` - Approved shift
 */
export enum ScheduleExceptionKindEnum {
    Adjustment = 'adjustment',
    Shift = 'shift'
}

/**
 * * `pre` - Pre-approval
 * * `post` - Post-factum
 */
export enum RequestTypeEnum {
    Pre = 'pre',
    Post = 'post'
}

/**
 * * `pending` - Pending
 * * `approved` - Approved
 * * `rejected` - Rejected
 * * `cancelled` - Cancelled
 */
export enum RequestStatusEnum {
    Pending = 'pending',
    Approved = 'approved',
    Rejected = 'rejected',
    Cancelled = 'cancelled'
}

/**
 * * `paid` - Paid leave
 * * `unpaid` - Unpaid leave
 * * `sick` - Sick leave
 * * `family_care` - Family care leave
 * * `maternity` - Maternity leave
 * * `parental` - Parental leave
 * * `study` - Study leave
 * * `compensatory` - Compensatory leave
 * * `bereavement` - Bereavement leave
 * * `other` - Other
 */
export enum LeaveTypeEnum {
    Paid = 'paid',
    Unpaid = 'unpaid',
    Sick = 'sick',
    FamilyCare = 'family_care',
    Maternity = 'maternity',
    Parental = 'parental',
    Study = 'study',
    Compensatory = 'compensatory',
    Bereavement = 'bereavement',
    Other = 'other'
}

/**
 * * `gekkyu` - Gekkyu
 * * `nikkyu` - Nikkyu
 * * `jikyu` - Jikyu
 */
export enum KyuyoKubunEnum {
    Gekkyu = 'gekkyu',
    Nikkyu = 'nikkyu',
    Jikyu = 'jikyu'
}

/**
 * * `male` - Male
 * * `female` - Female
 * * `not_set` - Not set
 */
export enum GenderEnum {
    Male = 'male',
    Female = 'female',
    NotSet = 'not_set'
}

/**
 * * `on_leave` - On leave
 * * `retired` - Retired
 * * `employed` - Currently employed
 */
export enum EmploymentStatusEnum {
    OnLeave = 'on_leave',
    Retired = 'retired',
    Employed = 'employed'
}

/**
 * * `employment_permanent` - Permanent Employee
 * * `employment_fixed_term` - Fixed-term Contract Employee
 * * `employment_part_time` - Part-time Employee
 * * `agency_worker` - Agency Worker
 * * `contractor` - Independent Contractor
 */
export enum EmployeeTypeEnum {
    EmploymentPermanent = 'employment_permanent',
    EmploymentFixedTerm = 'employment_fixed_term',
    EmploymentPartTime = 'employment_part_time',
    AgencyWorker = 'agency_worker',
    Contractor = 'contractor'
}

/**
 * * `fodder` - Fodder
 * * `fuel` - Fuel
 * * `travel` - Travel
 * * `accommodation` - Accommodation
 * * `meals` - Meals
 * * `supplies` - Supplies
 * * `equipment` - Equipment
 * * `communication` - Communication
 * * `other` - Other
 */
export enum CategoryEnum {
    Fodder = 'fodder',
    Fuel = 'fuel',
    Travel = 'travel',
    Accommodation = 'accommodation',
    Meals = 'meals',
    Supplies = 'supplies',
    Equipment = 'equipment',
    Communication = 'communication',
    Other = 'other'
}

/**
 * * `active` - Active
 * * `cancelled` - Cancelled
 */
export enum CalendarEventStatusEnum {
    Active = 'active',
    Cancelled = 'cancelled'
}

export enum BlankEnum {
    Value = ''
}

/**
 * * `new` - New
 * * `error` - Error
 * * `closed` - Closed
 * * `manual` - Manual
 */
export enum AccountingStatusEnum {
    New = 'new',
    Error = 'error',
    Closed = 'closed',
    Manual = 'manual'
}

export interface Activation {
    uid: string
    token: string
}

export interface ActivationRequest {
    /** @minLength 1 */
    uid: string
    /** @minLength 1 */
    token: string
}

export interface Branch {
    id: number
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Official branch name
     * @maxLength 255
     */
    name: string
    /**
     * Official branch name with kana
     * @maxLength 255
     */
    name_kana: string
    /**
     * Deleted
     * Branch is deleted
     */
    is_deleted?: boolean
    /** Determines if this branch can be used for calculations */
    enabled?: boolean
    notes?: string | null
    /**
     * Contact email
     * @maxLength 100
     */
    email?: string | null
    /**
     * WEB url
     * WEB url
     * @maxLength 200
     */
    url?: string | null
    /**
     * Latitude
     * Branch location N-S
     * @format double
     */
    location_latitude?: number | null
    /**
     * Longitude
     * Branch location E-W
     * @format double
     */
    location_longitude?: number | null
    /**
     * Branch spot radius inside which an employee is considered present at work, specified in meters
     * @format double
     */
    location_radius?: number | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** Employees who manage this branch */
    managers?: number[]
}

export interface BranchImportResponse {
    created: number
    updated: number
    errors: Record<string, any>[]
}

export interface BranchInline {
    id: number
    /** Official branch name */
    name: string
}

export interface BranchRequest {
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Official branch name
     * @minLength 1
     * @maxLength 255
     */
    name: string
    /**
     * Official branch name with kana
     * @minLength 1
     * @maxLength 255
     */
    name_kana: string
    /**
     * Deleted
     * Branch is deleted
     */
    is_deleted?: boolean
    /** Determines if this branch can be used for calculations */
    enabled?: boolean
    notes?: string | null
    /**
     * Contact email
     * @maxLength 100
     */
    email?: string | null
    /**
     * WEB url
     * WEB url
     * @maxLength 200
     */
    url?: string | null
    /**
     * Latitude
     * Branch location N-S
     * @format double
     */
    location_latitude?: number | null
    /**
     * Longitude
     * Branch location E-W
     * @format double
     */
    location_longitude?: number | null
    /**
     * Branch spot radius inside which an employee is considered present at work, specified in meters
     * @format double
     */
    location_radius?: number | null
    /** Employees who manage this branch */
    managers?: number[]
}

/** Serializer for grouped in/out event pairs. */
export interface CheckInOutPair {
    event_in: WorkEventInline | null
    event_out: WorkEventInline | null
    /** @format date-time */
    date: string
    /** Returns worktime in seconds, or None if in/out is missing. */
    worktime_length: number | null
}

export interface DayKind {
    id: number
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Human readable name
     * @maxLength 100
     */
    name: string
    /**
     * Start time
     * @format time
     */
    start_time: string
    /**
     * End time
     * @format time
     */
    end_time: string
    /** Rest duration */
    rest_time: string
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

export interface DayKindInline {
    id: number
    /** Human readable name */
    name: string
    /**
     * Start time
     * @format time
     */
    start_time: string
    /**
     * End time
     * @format time
     */
    end_time: string
    /** Rest duration */
    rest_time: string
}

export interface DayKindRequest {
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name: string
    /**
     * Start time
     * @format time
     */
    start_time: string
    /**
     * End time
     * @format time
     */
    end_time: string
    /** Rest duration */
    rest_time: string
}

export interface Employee {
    id: number
    is_manager: boolean
    /**
     * * `employment_permanent` - Permanent Employee
     * * `employment_fixed_term` - Fixed-term Contract Employee
     * * `employment_part_time` - Part-time Employee
     * * `agency_worker` - Agency Worker
     * * `contractor` - Independent Contractor
     */
    employee_type?: EmployeeTypeEnum
    /**
     * * `on_leave` - On leave
     * * `retired` - Retired
     * * `employed` - Currently employed
     */
    status?: EmploymentStatusEnum
    /** @format uri */
    avatar?: string | null
    branches_ids?: number[]
    branches: BranchInline[]
    /** @format date-time */
    last_login?: string | null
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username: string
    /** @maxLength 150 */
    first_name?: string
    /** @maxLength 150 */
    last_name?: string
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean
    /** @format date-time */
    date_joined?: string
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Deleted
     * Employee is deleted
     */
    is_deleted?: boolean
    /**
     * Employee ID
     * Individual worker ID
     * @min -2147483648
     * @max 2147483647
     */
    employee_code?: number | null
    /**
     * Last name reading, full-width katakana
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    last_name_kana: string
    /**
     * First name reading, full-width katakana
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    first_name_kana: string
    notes?: string | null
    /**
     * Start date
     * Employee working start date
     * @format date
     */
    working_start_date?: string | null
    /**
     * Birthdate
     * Employee birthdate
     * @format date
     */
    birth_date?: string | null
    /** @format date */
    retirement_date?: string | null
    /**
     * Employee gender
     *
     * * `male` - Male
     * * `female` - Female
     * * `not_set` - Not set
     */
    gender?: GenderEnum
    /**
     * Mobile phone number
     * @maxLength 20
     */
    mobile?: string | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
    groups?: number[]
}

/** Serializer for employee's grouped events for a specific day. */
export interface EmployeeEvents {
    employee: EmployeeInline
    /** @format date */
    date: string
    /** Returns total worktime in seconds (sum of all pairs). */
    worktime_length: number
    events: CheckInOutPair[]
}

export interface EmployeeImportResponse {
    created: number
    updated: number
    errors: Record<string, any>[]
}

export interface EmployeeInline {
    id: number
    first_name: string
    last_name: string
}

/** Serializer for /me/ endpoint — limits which fields a user can edit on themselves. */
export interface EmployeeMe {
    id: number
    /** @maxLength 150 */
    first_name?: string
    /** @maxLength 150 */
    last_name?: string
    /**
     * First name reading, full-width katakana
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    first_name_kana: string
    /**
     * Last name reading, full-width katakana
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    last_name_kana: string
    /** @format uri */
    avatar?: string | null
    /**
     * Birthdate
     * Employee birthdate
     * @format date
     */
    birth_date: string | null
    /**
     * Start date
     * Employee working start date
     * @format date
     */
    working_start_date: string | null
    /** @format date */
    retirement_date: string | null
    /**
     * Employee gender
     *
     * * `male` - Male
     * * `female` - Female
     * * `not_set` - Not set
     */
    gender: GenderEnum
    /** Contact phone number */
    phone: string | null
    /** Mobile phone number */
    mobile: string | null
    /** Fax number */
    fax: string | null
    /** Postal code */
    post_index: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     */
    address_1: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     */
    address_2: string | null
    /**
     * Employee ID
     * Individual worker ID
     */
    employee_code: number | null
    /**
     * Employee type
     *
     * * `employment_permanent` - Permanent Employee
     * * `employment_fixed_term` - Fixed-term Contract Employee
     * * `employment_part_time` - Part-time Employee
     * * `agency_worker` - Agency Worker
     * * `contractor` - Independent Contractor
     */
    employee_type: EmployeeTypeEnum
    /**
     * Employment status
     *
     * * `on_leave` - On leave
     * * `retired` - Retired
     * * `employed` - Currently employed
     */
    status: EmploymentStatusEnum
    /**
     * Derived from explicit branch management (``Branch.managers``).
     *
     * Cached per instance; instances live for one request.
     */
    is_manager: boolean
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff: boolean
    branches: BranchInline[]
    notes: string | null
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active: boolean
    /** @format date-time */
    last_login: string | null
    /** @format date-time */
    date_joined: string
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username: string
}

export interface EmployeeRequest {
    /**
     * * `employment_permanent` - Permanent Employee
     * * `employment_fixed_term` - Fixed-term Contract Employee
     * * `employment_part_time` - Part-time Employee
     * * `agency_worker` - Agency Worker
     * * `contractor` - Independent Contractor
     */
    employee_type?: EmployeeTypeEnum
    /**
     * * `on_leave` - On leave
     * * `retired` - Retired
     * * `employed` - Currently employed
     */
    status?: EmploymentStatusEnum
    /** @format binary */
    avatar?: File | null
    branches_ids?: number[]
    /** @format date-time */
    last_login?: string | null
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username: string
    /** @maxLength 150 */
    first_name?: string
    /** @maxLength 150 */
    last_name?: string
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean
    /** @format date-time */
    date_joined?: string
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Deleted
     * Employee is deleted
     */
    is_deleted?: boolean
    /**
     * Employee ID
     * Individual worker ID
     * @min -2147483648
     * @max 2147483647
     */
    employee_code?: number | null
    /**
     * Last name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    last_name_kana: string
    /**
     * First name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    first_name_kana: string
    notes?: string | null
    /**
     * Start date
     * Employee working start date
     * @format date
     */
    working_start_date?: string | null
    /**
     * Birthdate
     * Employee birthdate
     * @format date
     */
    birth_date?: string | null
    /** @format date */
    retirement_date?: string | null
    /**
     * Employee gender
     *
     * * `male` - Male
     * * `female` - Female
     * * `not_set` - Not set
     */
    gender?: GenderEnum
    /**
     * Mobile phone number
     * @maxLength 20
     */
    mobile?: string | null
    /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
    groups?: number[]
}

/** Mixin for detail serializers with review audit fields. */
export interface EventRequest {
    id: number
    employee: number
    employee_name: string
    /** Employee who created this object */
    created_by: number | null
    status: RequestStatusEnum
    /**
     * Event type
     * Clock in or clock out
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    event_kind: WorkEventKindEnum
    /**
     * Event datetime
     * Desired date and time for the clock event
     * @format date-time
     */
    recorded_at: string
    /** @format double */
    longitude?: number | null
    /** @format double */
    latitude?: number | null
    branch_id?: number | null
    branch_name: string
    reason: string
    reviewed_by: number | null
    reviewed_by_name: string | null
    /** @format date-time */
    reviewed_at: string | null
    reject_reason: string
    /** Created work event */
    work_event: number | null
    /**
     * Replaced work event
     * Same-kind stamp set to ignored on approval, e.g. the late clock-in the requested time corrects
     */
    replaced_event: number | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
}

/** Mixin providing the employee_name field. */
export interface EventRequestList {
    id: number
    employee: number
    employee_name: string
    branch_id: number | null
    /**
     * * `pending` - Pending
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     */
    status?: RequestStatusEnum
    /**
     * Event type
     * Clock in or clock out
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    event_kind: WorkEventKindEnum
    /**
     * Event datetime
     * Desired date and time for the clock event
     * @format date-time
     */
    recorded_at: string
    branch_name: string
    reason: string
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

/** Mixin for detail serializers with review audit fields. */
export interface EventRequestRequest {
    employee: number
    /**
     * Event type
     * Clock in or clock out
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    event_kind: WorkEventKindEnum
    /**
     * Event datetime
     * Desired date and time for the clock event
     * @format date-time
     */
    recorded_at: string
    /** @format double */
    longitude?: number | null
    /** @format double */
    latitude?: number | null
    branch_id?: number | null
    /** @minLength 1 */
    reason: string
}

export interface ExpenseReceipt {
    id: number
    url: string | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

/** Multipart receipt upload; the model's validators check the file. */
export interface ExpenseReceiptUploadRequest {
    /**
     * Receipt file
     * @format binary
     * @pattern (?:jpg|jpeg|png|webp|heic|heif|pdf)$
     */
    image: File
}

/** Mixin for detail serializers with review audit fields. */
export interface ExpenseRequest {
    id: number
    employee: number
    employee_name: string
    /** Employee who created this object */
    created_by: number | null
    status: RequestStatusEnum
    /** @format date */
    expense_date: string
    /**
     * * `fodder` - Fodder
     * * `fuel` - Fuel
     * * `travel` - Travel
     * * `accommodation` - Accommodation
     * * `meals` - Meals
     * * `supplies` - Supplies
     * * `equipment` - Equipment
     * * `communication` - Communication
     * * `other` - Other
     */
    category?: CategoryEnum
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    amount: string
    description: string
    reviewed_by: number | null
    reviewed_by_name: string | null
    /** @format date-time */
    reviewed_at: string | null
    reject_reason: string
    receipts: ExpenseReceipt[]
    expense: number
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
}

/** Mixin providing the employee_name field. */
export interface ExpenseRequestList {
    id: number
    employee: number
    employee_name: string
    /**
     * * `pending` - Pending
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     */
    status?: RequestStatusEnum
    /** @format date */
    expense_date: string
    /**
     * * `fodder` - Fodder
     * * `fuel` - Fuel
     * * `travel` - Travel
     * * `accommodation` - Accommodation
     * * `meals` - Meals
     * * `supplies` - Supplies
     * * `equipment` - Equipment
     * * `communication` - Communication
     * * `other` - Other
     */
    category?: CategoryEnum
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    amount: string
    receipt_count: number
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

/** Mixin for detail serializers with review audit fields. */
export interface ExpenseRequestRequest {
    employee: number
    /** @format date */
    expense_date: string
    /**
     * * `fodder` - Fodder
     * * `fuel` - Fuel
     * * `travel` - Travel
     * * `accommodation` - Accommodation
     * * `meals` - Meals
     * * `supplies` - Supplies
     * * `equipment` - Equipment
     * * `communication` - Communication
     * * `other` - Other
     */
    category?: CategoryEnum
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    amount: string
    /** @minLength 1 */
    description: string
}

export interface Holiday {
    id: number
    autogenerated: boolean
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Holiday name
     * @maxLength 255
     */
    name: string
    /**
     * Holiday date
     * @format date
     */
    date: string
    /** Additional notes */
    note?: string | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

export interface HolidayRequest {
    /**
     * Holiday name
     * @minLength 1
     * @maxLength 255
     */
    name: string
    /**
     * Holiday date
     * @format date
     */
    date: string
    /** Additional notes */
    note?: string | null
}

/**
 * Params for holiday sync + preview. `years` accepts a comma-separated
 * query param, repeated params, or a JSON list.
 */
export interface HolidaySyncRequestRequest {
    years?: number[]
}

export interface Leave {
    id: number
    employee_info: EmployeeInline
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Event start datetime
     * @format date-time
     */
    starts_at: string
    /**
     * Event end datetime
     * @format date-time
     */
    ends_at?: string | null
    /**
     * Event status
     *
     * * `active` - Active
     * * `cancelled` - Cancelled
     */
    status?: CalendarEventStatusEnum
    /** Additional notes */
    note?: string | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** Associated employee */
    employee?: number | null
}

export interface LeaveBalance {
    employee_id: number
    /**
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    leave_type: LeaveTypeEnum
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    accrued: string
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    carried_over: string
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    used: string
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    available: string
    /** @format date */
    as_of_date: string
}

export interface LeaveBalanceLedger {
    id: number
    employee: number
    /**
     * Type of leave this transaction applies to
     *
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    leave_type: LeaveTypeEnum
    transaction_type: TransactionTypeEnum
    /**
     * Amount (days)
     * Never negative; the transaction type decides whether it adds to or subtracts from the balance
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    amount: string
    /** @format date */
    effective_date: string
    source_type: SourceTypeEnum
    source_id: number | null
    comment: string
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

export interface LeaveBalanceSeedRequestRequest {
    /**
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    leave_type: LeaveTypeEnum
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    used_days: string
    /**
     * @minLength 1
     * @default ""
     */
    comment?: string
}

/** Mixin for detail serializers with review audit fields. */
export interface OvertimeRequest {
    id: number
    employee: number
    employee_name: string
    /** Employee who created this object */
    created_by: number | null
    /**
     * Target date
     * @format date
     */
    date: string
    /** @format time */
    start_time?: string | null
    /** @format time */
    end_time?: string | null
    /**
     * @format decimal
     * @pattern ^-?\d{0,2}(?:\.\d{0,2})?$
     */
    overtime_hours: string
    reason: string
    /**
     * * `pre` - Pre-approval
     * * `post` - Post-factum
     */
    request_type?: RequestTypeEnum
    status: RequestStatusEnum
    reviewed_by: number | null
    reviewed_by_name: string | null
    /** @format date-time */
    reviewed_at: string | null
    /** Rejection reason */
    reject_reason: string
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
}

/** Mixin providing the employee_name field. */
export interface OvertimeRequestList {
    id: number
    employee: number
    employee_name: string
    /**
     * Target date
     * @format date
     */
    date: string
    /** @format time */
    start_time?: string | null
    /** @format time */
    end_time?: string | null
    /**
     * @format decimal
     * @pattern ^-?\d{0,2}(?:\.\d{0,2})?$
     */
    overtime_hours: string
    /**
     * * `pre` - Pre-approval
     * * `post` - Post-factum
     */
    request_type?: RequestTypeEnum
    /**
     * * `pending` - Pending
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     */
    status?: RequestStatusEnum
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

/** Mixin for detail serializers with review audit fields. */
export interface OvertimeRequestRequest {
    employee: number
    /**
     * Target date
     * @format date
     */
    date: string
    /** @format time */
    start_time?: string | null
    /** @format time */
    end_time?: string | null
    /**
     * @format decimal
     * @pattern ^-?\d{0,2}(?:\.\d{0,2})?$
     */
    overtime_hours: string
    /** @minLength 1 */
    reason: string
    /**
     * * `pre` - Pre-approval
     * * `post` - Post-factum
     */
    request_type?: RequestTypeEnum
}

export interface PaginatedBranchList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: Branch[]
}

export interface PaginatedEmployeeEventsResponse {
    count: number
    total_pages: number
    current_page: number
    /** @format uri */
    next: string | null
    /** @format uri */
    previous: string | null
    results: EmployeeEvents[]
}

export interface PaginatedEmployeeList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: Employee[]
}

export interface PaginatedEventRequestListList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: EventRequestList[]
}

export interface PaginatedExpenseRequestListList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: ExpenseRequestList[]
}

export interface PaginatedOvertimeRequestListList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: OvertimeRequestList[]
}

export interface PaginatedStatementListList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: StatementList[]
}

export interface PaginatedVacationRequestListList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: VacationRequestList[]
}

export interface PaginatedWorkEventOutputList {
    /** @example 150 */
    count: number
    /** @example 3 */
    total_pages: number
    /** @example 1 */
    current_page: number
    /** @format uri */
    next?: string | null
    /** @format uri */
    previous?: string | null
    results: WorkEventOutput[]
}

export interface PasswordResetConfirm {
    uid: string
    token: string
    new_password: string
}

export interface PasswordResetConfirmRequest {
    /** @minLength 1 */
    uid: string
    /** @minLength 1 */
    token: string
    /** @minLength 1 */
    new_password: string
}

export interface PatchedBranchRequest {
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Official branch name
     * @minLength 1
     * @maxLength 255
     */
    name?: string
    /**
     * Official branch name with kana
     * @minLength 1
     * @maxLength 255
     */
    name_kana?: string
    /**
     * Deleted
     * Branch is deleted
     */
    is_deleted?: boolean
    /** Determines if this branch can be used for calculations */
    enabled?: boolean
    notes?: string | null
    /**
     * Contact email
     * @maxLength 100
     */
    email?: string | null
    /**
     * WEB url
     * WEB url
     * @maxLength 200
     */
    url?: string | null
    /**
     * Latitude
     * Branch location N-S
     * @format double
     */
    location_latitude?: number | null
    /**
     * Longitude
     * Branch location E-W
     * @format double
     */
    location_longitude?: number | null
    /**
     * Branch spot radius inside which an employee is considered present at work, specified in meters
     * @format double
     */
    location_radius?: number | null
    /** Employees who manage this branch */
    managers?: number[]
}

export interface PatchedDayKindRequest {
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name?: string
    /**
     * Start time
     * @format time
     */
    start_time?: string
    /**
     * End time
     * @format time
     */
    end_time?: string
    /** Rest duration */
    rest_time?: string
}

/** Serializer for /me/ endpoint — limits which fields a user can edit on themselves. */
export interface PatchedEmployeeMeRequest {
    /** @maxLength 150 */
    first_name?: string
    /** @maxLength 150 */
    last_name?: string
    /**
     * First name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    first_name_kana?: string
    /**
     * Last name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    last_name_kana?: string
    /** @format binary */
    avatar?: File | null
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username?: string
}

export interface PatchedEmployeeRequest {
    /**
     * * `employment_permanent` - Permanent Employee
     * * `employment_fixed_term` - Fixed-term Contract Employee
     * * `employment_part_time` - Part-time Employee
     * * `agency_worker` - Agency Worker
     * * `contractor` - Independent Contractor
     */
    employee_type?: EmployeeTypeEnum
    /**
     * * `on_leave` - On leave
     * * `retired` - Retired
     * * `employed` - Currently employed
     */
    status?: EmploymentStatusEnum
    /** @format binary */
    avatar?: File | null
    branches_ids?: number[]
    /** @format date-time */
    last_login?: string | null
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username?: string
    /** @maxLength 150 */
    first_name?: string
    /** @maxLength 150 */
    last_name?: string
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean
    /** @format date-time */
    date_joined?: string
    /**
     * Contact phone number
     * @maxLength 20
     */
    phone?: string | null
    /**
     * Fax number
     * @maxLength 20
     */
    fax?: string | null
    /**
     * Postal code
     * @maxLength 20
     */
    post_index?: string | null
    /**
     * Address line 1
     * Prefecture, city and chō, e.g. 東京都渋谷区神南
     * @maxLength 255
     */
    address_1?: string | null
    /**
     * Address line 2
     * Banchi, building name and room number, e.g. 1-2-3 ○○ビル101号室
     * @maxLength 255
     */
    address_2?: string | null
    /**
     * Deleted
     * Employee is deleted
     */
    is_deleted?: boolean
    /**
     * Employee ID
     * Individual worker ID
     * @min -2147483648
     * @max 2147483647
     */
    employee_code?: number | null
    /**
     * Last name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    last_name_kana?: string
    /**
     * First name reading, full-width katakana
     * @minLength 1
     * @maxLength 100
     * @pattern ^[\u30A0-\u30FF]+$
     */
    first_name_kana?: string
    notes?: string | null
    /**
     * Start date
     * Employee working start date
     * @format date
     */
    working_start_date?: string | null
    /**
     * Birthdate
     * Employee birthdate
     * @format date
     */
    birth_date?: string | null
    /** @format date */
    retirement_date?: string | null
    /**
     * Employee gender
     *
     * * `male` - Male
     * * `female` - Female
     * * `not_set` - Not set
     */
    gender?: GenderEnum
    /**
     * Mobile phone number
     * @maxLength 20
     */
    mobile?: string | null
    /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
    groups?: number[]
}

export interface PatchedHolidayRequest {
    /**
     * Holiday name
     * @minLength 1
     * @maxLength 255
     */
    name?: string
    /**
     * Holiday date
     * @format date
     */
    date?: string
    /** Additional notes */
    note?: string | null
}

export interface PatchedScheduleExceptionRequest {
    recurrence?: string
    schedule_id?: number
    day_kind_id?: number | null
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name?: string
    /** Additional notes */
    note?: string | null
    /** Employee's schedule this exception applies to */
    schedule?: number
}

export interface PatchedScheduleRequest {
    employee_id?: number
    year_template_id?: number
}

export interface PatchedTemplateExceptionRequest {
    recurrence?: string
    year_template_id?: number
    day_kind_id?: number | null
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name?: string
    /** Additional notes */
    note?: string | null
    /** Year template this exception applies to */
    year_template?: number
}

export interface PatchedUserActivityRequest {
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean
}

export interface PatchedUserRequest {
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
}

export interface PatchedWorkEventOutputRequest {
    /**
     * Event type
     * Event type
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    kind?: WorkEventKindEnum
    /**
     * Record date
     * Recorded event date
     * @format date-time
     */
    recorded_at?: string
    /**
     * Residence address longitude
     * @format double
     */
    longitude?: number | null
    /**
     * Residence address latitude
     * @format double
     */
    latitude?: number | null
    /**
     * Ignored
     * This event should be ignored when checking status or doing the accounting
     */
    ignore?: boolean
    /**
     * Used to make sure no duplicate event with this ID exists upon creation, defaults to random UUID
     * @minLength 1
     * @maxLength 64
     */
    idempotency_key?: string
}

export interface PatchedWorkdayWithEmployeeRequest {
    /** Notes */
    details?: string | null
}

export interface PatchedYearTemplateRequest {
    base_workday_id?: number
    base_weekend_id?: number
    /**
     * Human readable template name
     * @minLength 1
     * @maxLength 100
     */
    name?: string
    /**
     * Schedule year
     * @min 0
     * @max 32767
     */
    year?: number
}

/** Payment slip (給与明細書) part of a statement. */
export interface PaymentSlip {
    /**
     * Base pay
     * @format double
     */
    honkyu?: number | null
    /**
     * Executive remuneration
     * @format double
     */
    yakuin_hoshu?: number | null
    /**
     * Position allowance
     * @format double
     */
    yakushoku_teate?: number | null
    /**
     * Manager allowance
     * @format double
     */
    kanrisha_teate?: number | null
    /**
     * Fixed overtime allowance
     * @format double
     */
    zangyo_teate?: number | null
    /**
     * Other allowance
     * @format double
     */
    sonota_teate?: number | null
    /**
     * Bird-catching fee
     * @format double
     */
    hochodai?: number | null
    /**
     * New Year allowance
     * @format double
     */
    shogatsu_teate?: number | null
    /**
     * Trainee supervision allowance
     * @format double
     */
    jisshusei_kanri_teate?: number | null
    /**
     * Chusan performance allowance
     * @format double
     */
    chusan_seiseki_teate?: number | null
    /**
     * Unused allowance slot 9
     * @format double
     */
    teate_9?: number | null
    /**
     * Unused allowance slot 10
     * @format double
     */
    teate_10?: number | null
    /**
     * Overtime pay
     * @format double
     */
    jikangai_teate?: number | null
    /**
     * Late-night pay
     * @format double
     */
    shinya_teate?: number | null
    /**
     * Holiday pay
     * @format double
     */
    kyujitsu_teate?: number | null
    /**
     * Holiday late-night pay
     * @format double
     */
    kyujitsu_shinya_teate?: number | null
    /**
     * Pay for other hours
     * @format double
     */
    sonota_jikan_teate?: number | null
    /**
     * Day/night duty allowance
     * @format double
     */
    nisshuku_teate?: number | null
    /**
     * Commuting allowance, non-taxable
     * @format double
     */
    tsukinhi_hikazei?: number | null
    /**
     * Commuting allowance, taxable
     * @format double
     */
    tsukinhi_kazei?: number | null
    /**
     * Absence deduction
     * @format double
     */
    kekkin_kojo?: number | null
    /**
     * Lateness deduction
     * @format double
     */
    chikoku_kojo?: number | null
    /**
     * Early-leave deduction
     * @format double
     */
    sotai_kojo?: number | null
    /**
     * Gross pay
     * @format double
     */
    soshikyugaku?: number | null
    /**
     * Health insurance premium
     * @format double
     */
    kenko_hokenryo?: number | null
    /**
     * Nursing-care insurance premium
     * @format double
     */
    kaigo_hokenryo?: number | null
    /**
     * Employees' pension insurance premium
     * @format double
     */
    kosei_nenkin_hokenryo?: number | null
    /**
     * Employment insurance premium
     * @format double
     */
    koyo_hokenryo?: number | null
    /**
     * Taxable amount (informational, not part of total deductions)
     * @format double
     */
    kazei_taishogaku?: number | null
    /**
     * Resident tax
     * @format double
     */
    juminzei?: number | null
    /**
     * Income tax
     * @format double
     */
    shotokuzei?: number | null
    /**
     * Prepaid commuter pass
     * @format double
     */
    kibarai_teikidai?: number | null
    /**
     * Other social insurance premium
     * @format double
     */
    sonota_shakai_hokenryo?: number | null
    /**
     * Loan repayment
     * @format double
     */
    kashitsukekin_hensai?: number | null
    /**
     * Rent contribution
     * @format double
     */
    yachin_futankin?: number | null
    /**
     * Internet fee
     * @format double
     */
    internet_dai?: number | null
    /**
     * Living expenses
     * @format double
     */
    seikatsuhi?: number | null
    /**
     * Unused deduction slot 6
     * @format double
     */
    kojo_6?: number | null
    /**
     * Unused deduction slot 7
     * @format double
     */
    kojo_7?: number | null
    /**
     * Reimbursed advances (normally negative)
     * @format double
     */
    tatekaekin?: number | null
    /**
     * Other deduction
     * @format double
     */
    sonota_kojo?: number | null
    /**
     * Year-end tax adjustment
     * @format double
     */
    nenmatsu_choseikin?: number | null
    /**
     * Total deductions
     * @format double
     */
    kojo_gokei?: number | null
    /**
     * Rounding amount carried over from the previous month
     * @format double
     */
    zengetsu_tangaku?: number | null
    /**
     * Rounding amount carried over to the next month
     * @format double
     */
    togetsu_tangaku?: number | null
    /**
     * Net pay
     * @format double
     */
    sashihiki_shikyugaku?: number | null
}

export interface RejectReasonRequest {
    /** @minLength 1 */
    reason: string
}

export interface RosterDay {
    /** @format date */
    date: string
    holiday: string | null
    working: RosterShift[]
    unscheduled: RosterEmployee[]
}

export interface RosterDaySummary {
    /** @format date */
    date: string
    holiday: string | null
    working_count: number
    unscheduled_count: number
}

export interface RosterEmployee {
    id: number
    first_name: string
    last_name: string
    /** First name reading, full-width katakana */
    first_name_kana: string
    /** Last name reading, full-width katakana */
    last_name_kana: string
    branches: BranchInline[]
}

export interface RosterShift {
    employee: RosterEmployee
    /** @format time */
    start_time: string
    /** @format time */
    end_time: string
    rest_time: string
    /** Day kind or schedule exception the hours come from */
    label: string
}

export interface Schedule {
    id: number
    employee_id: number
    year_template_id: number
    employee: EmployeeInline
    year_template: YearTemplate
    exceptions: ScheduleException[]
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

export interface ScheduleException {
    id: number
    recurrence: string
    schedule_id: number
    day_kind_id?: number | null
    day_kind: DayKindInline
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Human readable name
     * @maxLength 100
     */
    name: string
    /** Additional notes */
    note?: string | null
    /**
     * Approved shifts are created by the overtime workflow; everything else is a schedule adjustment
     *
     * * `adjustment` - Schedule adjustment
     * * `shift` - Approved shift
     */
    kind: ScheduleExceptionKindEnum
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** Employee's schedule this exception applies to */
    schedule: number
}

export interface ScheduleExceptionRequest {
    recurrence: string
    schedule_id: number
    day_kind_id?: number | null
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name: string
    /** Additional notes */
    note?: string | null
    /** Employee's schedule this exception applies to */
    schedule: number
}

export interface ScheduleRequest {
    employee_id: number
    year_template_id: number
}

export interface SendEmailReset {
    /** @format email */
    email: string
}

export interface SendEmailResetRequest {
    /**
     * @format email
     * @minLength 1
     */
    email: string
}

export interface SetPassword {
    new_password: string
    current_password: string
}

export interface SetPasswordRequest {
    /** @minLength 1 */
    new_password: string
    /** @minLength 1 */
    current_password: string
}

export interface SetUsername {
    current_password: string
    /**
     * Username
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    new_username: string
}

export interface SetUsernameRequest {
    /** @minLength 1 */
    current_password: string
    /**
     * Username
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    new_username: string
}

/** Full statement with its optional payment and worktime slips. */
export interface StatementDetail {
    id: number
    employee: StatementEmployee
    payment_slip: PaymentSlip | null
    worktime_slip: WorktimeSlip | null
    /**
     * Western year of the period this statement applies to
     * @min 0
     * @max 32767
     */
    period_year?: number | null
    /**
     * Month of the period this statement applies to
     * @min 1
     * @max 12
     */
    period_month?: number | null
    /**
     * Date the salary is paid
     * @format date
     */
    payment_date?: string | null
    /**
     * Pay type; hourly pay prints hours and an hourly rate where the others print days and a daily rate
     *
     * * `gekkyu` - Gekkyu
     * * `nikkyu` - Nikkyu
     * * `jikyu` - Jikyu
     */
    kyuyo_kubun?: KyuyoKubunEnum | BlankEnum
    /**
     * Own tax category (e.g. widow, single parent)
     * @maxLength 32
     */
    honnin_kubun?: string
    /**
     * Spouse deduction status
     * @maxLength 32
     */
    haigusha?: string
    /**
     * Number of dependents
     * @maxLength 32
     */
    fuyoshasu?: string
    /**
     * Disabled persons in household
     * @maxLength 32
     */
    shogaisha?: string
    /**
     * Withholding tax table column
     * @maxLength 32
     */
    zeigakuhyo?: string
    /**
     * Working days
     * @maxLength 32
     */
    rodo_nissu?: string
    /** Working hours; replaces working days on slips of hourly-paid employees */
    rodo_jikan?: string | null
    /**
     * Daily rate
     * @format double
     */
    nikkyu_tanka?: number | null
    /**
     * Hourly rate; replaces the daily rate on slips of hourly-paid employees
     * @format double
     */
    jikyu_tanka?: number | null
    /**
     * Absence rate
     * @format double
     */
    kekkin_tanka?: number | null
    /**
     * Lateness rate
     * @format double
     */
    chikoku_tanka?: number | null
    /**
     * Early-leave rate
     * @format double
     */
    sotai_tanka?: number | null
    /**
     * Overtime hourly rate
     * @format double
     */
    jikangai_tanka?: number | null
    /**
     * Late-night hourly rate
     * @format double
     */
    shinya_tanka?: number | null
    /**
     * Holiday hourly rate
     * @format double
     */
    kyujitsu_tanka?: number | null
    /**
     * Holiday late-night hourly rate
     * @format double
     */
    kyujitsu_shinya_tanka?: number | null
    /**
     * Other-hours hourly rate
     * @format double
     */
    sonota_jikan_tanka?: number | null
    /**
     * Day/night duty rate
     * @format double
     */
    nisshuku_tanka?: number | null
    /**
     * Employment insurance rate
     * @format double
     */
    koyoritsu?: number | null
    /**
     * Retiree name
     * @maxLength 64
     */
    taishokusha?: string
    /** Has non-taxable pay */
    hikazei?: boolean | null
    /**
     * Taxable amount, year to date
     * @format double
     */
    kazei_taishogaku_ruikei?: number | null
    /**
     * Taxable pay, year to date
     * @format double
     */
    kazei_shikyu_ruikei?: number | null
    /**
     * Social insurance, year to date
     * @format double
     */
    shakai_hoken_ruikei?: number | null
    /**
     * Income tax, year to date
     * @format double
     */
    shotokuzei_ruikei?: number | null
}

/** What a slip prints about its employee: code, names and sex. */
export interface StatementEmployee {
    id: number
    /**
     * Employee ID
     * Individual worker ID
     */
    employee_code: number | null
    last_name: string
    first_name: string
    /** Last name reading, full-width katakana */
    last_name_kana: string
    /** First name reading, full-width katakana */
    first_name_kana: string
    /**
     * Employee gender
     *
     * * `male` - Male
     * * `female` - Female
     * * `not_set` - Not set
     */
    gender: GenderEnum
}

/** Statement list row: period plus gross/net pay of its payment slip. */
export interface StatementList {
    id: number
    /**
     * Western year of the period this statement applies to
     * @min 0
     * @max 32767
     */
    period_year?: number | null
    /**
     * Month of the period this statement applies to
     * @min 1
     * @max 12
     */
    period_month?: number | null
    /**
     * Date the salary is paid
     * @format date
     */
    payment_date?: string | null
    /**
     * Pay type; hourly pay prints hours and an hourly rate where the others print days and a daily rate
     *
     * * `gekkyu` - Gekkyu
     * * `nikkyu` - Nikkyu
     * * `jikyu` - Jikyu
     */
    kyuyo_kubun?: KyuyoKubunEnum | BlankEnum
    /**
     * Gross pay (総支給額)
     * @format double
     */
    soshikyugaku: number | null
    /**
     * Net pay (差引支給額)
     * @format double
     */
    sashihiki_shikyugaku: number | null
}

export interface TemplateException {
    id: number
    recurrence: string
    year_template_id: number
    day_kind_id?: number | null
    day_kind: DayKindInline
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Human readable name
     * @maxLength 100
     */
    name: string
    /** Additional notes */
    note?: string | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** Year template this exception applies to */
    year_template: number
}

export interface TemplateExceptionRequest {
    recurrence: string
    year_template_id: number
    day_kind_id?: number | null
    /**
     * Human readable name
     * @minLength 1
     * @maxLength 100
     */
    name: string
    /** Additional notes */
    note?: string | null
    /** Year template this exception applies to */
    year_template: number
}

export interface TokenObtainPair {
    access: string
    refresh: string
}

export interface TokenObtainPairRequest {
    /** @minLength 1 */
    username: string
    /** @minLength 1 */
    password: string
}

export interface TokenRefresh {
    access: string
}

export interface TokenRefreshRequest {
    /** @minLength 1 */
    refresh: string
}

export interface TokenVerifyRequest {
    /** @minLength 1 */
    token: string
}

export interface User {
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    id: number
    /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
    username: string
}

export interface UserActivity {
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean
}

export interface UserCreate {
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username: string
    id: number
}

export interface UserCreateRequest {
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    username: string
    /** @minLength 1 */
    password: string
}

export interface UserRequest {
    /**
     * Email address
     * @format email
     * @maxLength 254
     */
    email?: string
}

export interface UsernameResetConfirm {
    /**
     * Username
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    new_username: string
}

export interface UsernameResetConfirmRequest {
    /**
     * Username
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @minLength 1
     * @maxLength 150
     * @pattern ^[\w.@+-]+$
     */
    new_username: string
}

/** Mixin for detail serializers with review audit fields. */
export interface VacationRequest {
    id: number
    employee: number
    employee_name: string
    /** Employee who created this object */
    created_by: number | null
    status: RequestStatusEnum
    /**
     * Start date
     * @format date
     */
    date_from: string
    /**
     * End date
     * @format date
     */
    date_to: string
    /**
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    vacation_type?: LeaveTypeEnum
    reason?: string
    reviewed_by: number | null
    reviewed_by_name: string | null
    /** @format date-time */
    reviewed_at: string | null
    reject_reason: string
    leave: number | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
}

/** Mixin providing the employee_name field. */
export interface VacationRequestList {
    id: number
    employee: number
    employee_name: string
    /**
     * * `pending` - Pending
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     */
    status?: RequestStatusEnum
    /**
     * Start date
     * @format date
     */
    date_from: string
    /**
     * End date
     * @format date
     */
    date_to: string
    /**
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    vacation_type?: LeaveTypeEnum
    leave?: number | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
}

/** Mixin for detail serializers with review audit fields. */
export interface VacationRequestRequest {
    employee: number
    /**
     * Start date
     * @format date
     */
    date_from: string
    /**
     * End date
     * @format date
     */
    date_to: string
    /**
     * * `paid` - Paid leave
     * * `unpaid` - Unpaid leave
     * * `sick` - Sick leave
     * * `family_care` - Family care leave
     * * `maternity` - Maternity leave
     * * `parental` - Parental leave
     * * `study` - Study leave
     * * `compensatory` - Compensatory leave
     * * `bereavement` - Bereavement leave
     * * `other` - Other
     */
    vacation_type?: LeaveTypeEnum
    reason?: string
}

export interface WorkDayWithEmployeeInline {
    id: number
    /**
     * The date of this workday
     * @format date
     */
    date: string
    /**
     * Workday status, not to be confused with accounting status.
     *
     * * `new` - New
     * * `working` - Working
     * * `finished` - Finished
     */
    status: WorkdayStatusEnum
    /** Calculated total work time */
    total_time: string | null
    /** Set if there are period inconsistencies */
    inconsistent: boolean
    /** This workday was not created from schedule or has been modified. */
    ad_hoc: boolean
    employee: EmployeeInline
}

/** Only what clients are allowed to send on create. */
export interface WorkEventCreateInputRequest {
    /**
     * Event type
     * Event type
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    kind: WorkEventKindEnum
    /**
     * Record date
     * Recorded event date
     * @format date-time
     */
    recorded_at: string
    /**
     * Residence address longitude
     * @format double
     */
    longitude: number | null
    /**
     * Residence address latitude
     * @format double
     */
    latitude: number | null
    event_employee?: number
    /**
     * Used to make sure no duplicate event with this ID exists upon creation, defaults to random UUID
     * @minLength 1
     * @maxLength 64
     */
    idempotency_key: string
}

export interface WorkEventIngestOutput {
    created: WorkEventOutput[]
    skipped: Record<string, any>[]
}

export interface WorkEventInline {
    id: number
    branch_id: number | null
    branch_name: string | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Event type
     * Event type
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    kind: WorkEventKindEnum
    /**
     * Record date
     * Recorded event date
     * @format date-time
     */
    recorded_at: string
    /**
     * Residence address longitude
     * @format double
     */
    longitude?: number | null
    /**
     * Residence address latitude
     * @format double
     */
    latitude?: number | null
    /**
     * Ignored
     * This event should be ignored when checking status or doing the accounting
     */
    ignore?: boolean
    /**
     * Used to make sure no duplicate event with this ID exists upon creation, defaults to random UUID
     * @maxLength 64
     */
    idempotency_key: string
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
    /** Working day this event belongs to */
    workday: number
    /** Employee who recorded this event; may differ from the workday employee, e.g. a manager clocking in a subordinate */
    owner: number
}

export interface WorkEventInlineRequest {
    /**
     * Event type
     * Event type
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    kind: WorkEventKindEnum
    /**
     * Record date
     * Recorded event date
     * @format date-time
     */
    recorded_at: string
    /**
     * Residence address longitude
     * @format double
     */
    longitude?: number | null
    /**
     * Residence address latitude
     * @format double
     */
    latitude?: number | null
    /**
     * Ignored
     * This event should be ignored when checking status or doing the accounting
     */
    ignore?: boolean
    /**
     * Used to make sure no duplicate event with this ID exists upon creation, defaults to random UUID
     * @minLength 1
     * @maxLength 64
     */
    idempotency_key: string
    /** Working day this event belongs to */
    workday: number
    /** Employee who recorded this event; may differ from the workday employee, e.g. a manager clocking in a subordinate */
    owner: number
}

export interface WorkEventOutput {
    id: number
    branch_id: number | null
    branch_name: string | null
    owner: EmployeeInline | null
    workday: WorkDayWithEmployeeInline | null
    employee: EmployeeInline | null
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Event type
     * Event type
     *
     * * `in` - Clock In
     * * `out` - Clock Out
     */
    kind: WorkEventKindEnum
    /**
     * Record date
     * Recorded event date
     * @format date-time
     */
    recorded_at: string
    /**
     * Residence address longitude
     * @format double
     */
    longitude?: number | null
    /**
     * Residence address latitude
     * @format double
     */
    latitude?: number | null
    /**
     * Ignored
     * This event should be ignored when checking status or doing the accounting
     */
    ignore?: boolean
    /**
     * Used to make sure no duplicate event with this ID exists upon creation, defaults to random UUID
     * @maxLength 64
     */
    idempotency_key: string
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

export interface WorkEventPollResponse {
    has_changes: boolean
    count: number
    /** @format date-time */
    latest: string | null
}

export interface WorkdayWithEmployee {
    id: number
    employee: EmployeeInline
    events: WorkEventInline[]
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * The date of this workday
     * @format date
     */
    date: string
    /**
     * Schedule start time
     * @format time
     */
    start_time: string | null
    /**
     * Schedule end time
     * @format time
     */
    end_time: string | null
    /** Schedule rest time */
    rest_time: string | null
    /** Calculated total work time */
    total_time: string | null
    /**
     * Workday status, not to be confused with accounting status.
     *
     * * `new` - New
     * * `working` - Working
     * * `finished` - Finished
     */
    status: WorkdayStatusEnum
    /** Calculated worktime as gathered from events */
    work_time: string | null
    /**
     * Overtime
     * Calculated overwork time, can be trusted when status is Finished only
     */
    over_time: string | null
    /** Set if there are period inconsistencies */
    inconsistent: boolean
    /** This workday was not created from schedule or has been modified. */
    ad_hoc: boolean
    /**
     * Workday accounting status, determines if work time and overtime calculations can be used.<ul><li>New: Mot processed yet</li><li>Error: System identified errors when attempting to calculate schedule times</li><li>Closed: Workday has been processed and contains complete schedule data</li><li>Manual: Workday can not be automatically accounted, time data must not be trusted</li></ul>
     *
     * * `new` - New
     * * `error` - Error
     * * `closed` - Closed
     * * `manual` - Manual
     */
    accounting_status: AccountingStatusEnum
    /** This workday has been checked and is considered approved */
    approved: boolean
    /** Notes */
    details?: string | null
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

/** Worktime slip (勤務明細書) part of a statement. */
export interface WorktimeSlip {
    /**
     * Days attended
     * @format double
     */
    shukkin_nissu?: number | null
    /** Hours attended; replaces days attended on slips of hourly-paid employees */
    shukkin_jikan?: string | null
    /**
     * Days absent
     * @format double
     */
    kekkin_nissu?: number | null
    /** Hours absent; replaces days absent on slips of hourly-paid employees */
    kekkin_jikan?: string | null
    /**
     * Number of late arrivals
     * @min 0
     * @max 32767
     */
    chikoku_kaisu?: number | null
    /**
     * Number of early leaves
     * @min 0
     * @max 32767
     */
    sotai_kaisu?: number | null
    /** Overtime hours */
    jikangai_jikan?: string | null
    /** Late-night hours */
    shinya_jikan?: string | null
    /** Holiday hours */
    kyujitsu_jikan?: string | null
    /** Holiday late-night hours */
    kyujitsu_shinya_jikan?: string | null
    /** Other hours */
    sonota_jikan?: string | null
    /**
     * Number of day/night duties
     * @min 0
     * @max 32767
     */
    nisshuku_kaisu?: number | null
    /**
     * Paid leave days carried over from the previous month
     * @format double
     */
    zengetsu_yukyu?: number | null
    /**
     * Paid leave days taken this month
     * @format double
     */
    togetsu_yukyu?: number | null
    /**
     * Paid leave days remaining after this month
     * @format double
     */
    yukyu_zan?: number | null
}

export interface YearTemplate {
    id: number
    base_workday_id: number
    base_weekend_id: number
    base_workday: DayKindInline
    base_weekend: DayKindInline
    exceptions: TemplateException[]
    /**
     * Object creation time
     * @format date-time
     */
    created_at: string
    /**
     * Object modification time
     * @format date-time
     */
    modified_at: string
    /**
     * Human readable template name
     * @maxLength 100
     */
    name: string
    /**
     * Schedule year
     * @min 0
     * @max 32767
     */
    year: number
    /** Employee who created this object */
    created_by: number | null
    /** Employee who last modified this object */
    modified_by: number | null
}

export interface YearTemplateRequest {
    base_workday_id: number
    base_weekend_id: number
    /**
     * Human readable template name
     * @minLength 1
     * @maxLength 100
     */
    name: string
    /**
     * Schedule year
     * @min 0
     * @max 32767
     */
    year: number
}

import { ContentType, HttpClient, RequestParams } from '../http-client-base'

/**
 * @title Kawafuji backend API
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * @description Statements (明細書) of the current user, read-only. Always scoped to the requesting employee, staff included; the full list lives in the admin. Drafts (no period yet) are not exposed.
         *
         * @tags Statement
         * @name AccountingStatementsList
         * @summary List own statements
         * @request GET:/api/accounting/statements/
         * @secure
         */
        accountingStatementsList: (
            query?: {
                /** Period month (1-12) */
                month?: number
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** Period year (western, YYYY) */
                year?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedStatementListList, any>({
                path: `/api/accounting/statements/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Statements (明細書) of the current user, read-only. Always scoped to the requesting employee, staff included; the full list lives in the admin. Drafts (no period yet) are not exposed.
         *
         * @tags Statement
         * @name AccountingStatementsRetrieve
         * @summary Get own statement
         * @request GET:/api/accounting/statements/{id}/
         * @secure
         */
        accountingStatementsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<StatementDetail, any>({
                path: `/api/accounting/statements/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersList
         * @request GET:/api/auth/users/
         * @secure
         */
        authUsersList: (
            query?: {
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<User[], any>({
                path: `/api/auth/users/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersCreate
         * @request POST:/api/auth/users/
         * @secure
         */
        authUsersCreate: (data: UserCreateRequest, params: RequestParams = {}) =>
            this.request<UserCreate, any>({
                path: `/api/auth/users/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersRetrieve
         * @request GET:/api/auth/users/{id}/
         * @secure
         */
        authUsersRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersUpdate
         * @request PUT:/api/auth/users/{id}/
         * @secure
         */
        authUsersUpdate: (id: number, data: UserRequest, params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersPartialUpdate
         * @request PATCH:/api/auth/users/{id}/
         * @secure
         */
        authUsersPartialUpdate: (id: number, data: PatchedUserRequest, params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersDestroy
         * @request DELETE:/api/auth/users/{id}/
         * @secure
         */
        authUsersDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/auth/users/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersActivationPartialUpdate
         * @request PATCH:/api/auth/users/{id}/activation/
         * @secure
         */
        authUsersActivationPartialUpdate: (id: number, data: PatchedUserActivityRequest, params: RequestParams = {}) =>
            this.request<UserActivity, void>({
                path: `/api/auth/users/${id}/activation/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersSetPasswordCreate2
         * @request POST:/api/auth/users/{id}/set_password/
         * @secure
         */
        authUsersSetPasswordCreate2: (id: number, data: Record<string, any>, params: RequestParams = {}) =>
            this.request<void, void>({
                path: `/api/auth/users/${id}/set_password/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersActivationCreate
         * @request POST:/api/auth/users/activation/
         * @secure
         */
        authUsersActivationCreate: (data: ActivationRequest, params: RequestParams = {}) =>
            this.request<Activation, any>({
                path: `/api/auth/users/activation/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersMeRetrieve
         * @request GET:/api/auth/users/me/
         * @secure
         */
        authUsersMeRetrieve: (params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/me/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersMeUpdate
         * @request PUT:/api/auth/users/me/
         * @secure
         */
        authUsersMeUpdate: (data: UserRequest, params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/me/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersMePartialUpdate
         * @request PATCH:/api/auth/users/me/
         * @secure
         */
        authUsersMePartialUpdate: (data: PatchedUserRequest, params: RequestParams = {}) =>
            this.request<User, any>({
                path: `/api/auth/users/me/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersMeDestroy
         * @request DELETE:/api/auth/users/me/
         * @secure
         */
        authUsersMeDestroy: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/auth/users/me/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersResendActivationCreate
         * @request POST:/api/auth/users/resend_activation/
         * @secure
         */
        authUsersResendActivationCreate: (data: SendEmailResetRequest, params: RequestParams = {}) =>
            this.request<SendEmailReset, any>({
                path: `/api/auth/users/resend_activation/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersResetPasswordCreate
         * @request POST:/api/auth/users/reset_password/
         * @secure
         */
        authUsersResetPasswordCreate: (data: SendEmailResetRequest, params: RequestParams = {}) =>
            this.request<SendEmailReset, any>({
                path: `/api/auth/users/reset_password/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersResetPasswordConfirmCreate
         * @request POST:/api/auth/users/reset_password_confirm/
         * @secure
         */
        authUsersResetPasswordConfirmCreate: (data: PasswordResetConfirmRequest, params: RequestParams = {}) =>
            this.request<PasswordResetConfirm, any>({
                path: `/api/auth/users/reset_password_confirm/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersResetUsernameCreate
         * @request POST:/api/auth/users/reset_username/
         * @secure
         */
        authUsersResetUsernameCreate: (data: SendEmailResetRequest, params: RequestParams = {}) =>
            this.request<SendEmailReset, any>({
                path: `/api/auth/users/reset_username/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersResetUsernameConfirmCreate
         * @request POST:/api/auth/users/reset_username_confirm/
         * @secure
         */
        authUsersResetUsernameConfirmCreate: (data: UsernameResetConfirmRequest, params: RequestParams = {}) =>
            this.request<UsernameResetConfirm, any>({
                path: `/api/auth/users/reset_username_confirm/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersSetPasswordCreate
         * @request POST:/api/auth/users/set_password/
         * @secure
         */
        authUsersSetPasswordCreate: (data: SetPasswordRequest, params: RequestParams = {}) =>
            this.request<SetPassword, any>({
                path: `/api/auth/users/set_password/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags auth
         * @name AuthUsersSetUsernameCreate
         * @request POST:/api/auth/users/set_username/
         * @secure
         */
        authUsersSetUsernameCreate: (data: SetUsernameRequest, params: RequestParams = {}) =>
            this.request<SetUsername, any>({
                path: `/api/auth/users/set_username/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesList
         * @request GET:/api/company/branches/
         * @secure
         */
        companyBranchesList: (
            query?: {
                id?: number
                /** Multiple values may be separated by commas. */
                id__in?: number[]
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** Search term. Searched across keys: name, name_kana, id, address */
                search?: string
                /** Limit search to specific key(s). Allowed values: name, name_kana, id, address. Can be repeated (e.g. ?searchKey=name&searchKey=name_kana). If omitted, all keys are searched. */
                searchKey?: 'name' | 'name_kana' | 'id' | 'address'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedBranchList, any>({
                path: `/api/company/branches/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesCreate
         * @request POST:/api/company/branches/
         * @secure
         */
        companyBranchesCreate: (data: BranchRequest, params: RequestParams = {}) =>
            this.request<Branch, any>({
                path: `/api/company/branches/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesRetrieve
         * @request GET:/api/company/branches/{id}/
         * @secure
         */
        companyBranchesRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<Branch, any>({
                path: `/api/company/branches/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesUpdate
         * @request PUT:/api/company/branches/{id}/
         * @secure
         */
        companyBranchesUpdate: (id: number, data: BranchRequest, params: RequestParams = {}) =>
            this.request<Branch, any>({
                path: `/api/company/branches/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesPartialUpdate
         * @request PATCH:/api/company/branches/{id}/
         * @secure
         */
        companyBranchesPartialUpdate: (id: number, data: PatchedBranchRequest, params: RequestParams = {}) =>
            this.request<Branch, any>({
                path: `/api/company/branches/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyBranchesDestroy
         * @request DELETE:/api/company/branches/{id}/
         * @secure
         */
        companyBranchesDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/company/branches/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description Export filtered branches as CSV.
         *
         * @tags Branches
         * @name BranchesCsv
         * @summary Export branches as CSV
         * @request GET:/api/company/branches/csv/
         * @secure
         */
        branchesCsv: (params: RequestParams = {}) =>
            this.request<File, any>({
                path: `/api/company/branches/csv/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Import branches from CSV (same schema as export).
         *
         * @tags Branches
         * @name BranchesImportCsv
         * @summary Import branches from CSV
         * @request POST:/api/company/branches/import-csv/
         * @secure
         */
        branchesImportCsv: (
            data: {
                /** @format binary */
                file: File
            },
            params: RequestParams = {}
        ) =>
            this.request<BranchImportResponse, any>({
                path: `/api/company/branches/import-csv/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesList
         * @request GET:/api/company/employees/
         * @secure
         */
        companyEmployeesList: (
            query?: {
                /** Multiple values may be separated by commas. */
                branch?: number[]
                /** Multiple values may be separated by commas. */
                branch_ids__in?: number[]
                /** Multiple values may be separated by commas. */
                id__in?: number[]
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** Search term. Searched across keys: name, name_kana, id, employee_code */
                search?: string
                /** Limit search to specific key(s). Allowed values: name, name_kana, id, employee_code. Can be repeated (e.g. ?searchKey=name&searchKey=name_kana). If omitted, all keys are searched. */
                searchKey?: 'name' | 'name_kana' | 'id' | 'employee_code'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedEmployeeList, any>({
                path: `/api/company/employees/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesCreate
         * @request POST:/api/company/employees/
         * @secure
         */
        companyEmployeesCreate: (data: EmployeeRequest, params: RequestParams = {}) =>
            this.request<Employee, any>({
                path: `/api/company/employees/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesRetrieve
         * @request GET:/api/company/employees/{id}/
         * @secure
         */
        companyEmployeesRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<Employee, any>({
                path: `/api/company/employees/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesUpdate
         * @request PUT:/api/company/employees/{id}/
         * @secure
         */
        companyEmployeesUpdate: (id: number, data: EmployeeRequest, params: RequestParams = {}) =>
            this.request<Employee, any>({
                path: `/api/company/employees/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesPartialUpdate
         * @request PATCH:/api/company/employees/{id}/
         * @secure
         */
        companyEmployeesPartialUpdate: (id: number, data: PatchedEmployeeRequest, params: RequestParams = {}) =>
            this.request<Employee, any>({
                path: `/api/company/employees/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesDestroy
         * @request DELETE:/api/company/employees/{id}/
         * @secure
         */
        companyEmployeesDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/company/employees/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description Export filtered employees as CSV.
         *
         * @tags Employees
         * @name EmployeesCsv
         * @summary Export employees as CSV
         * @request GET:/api/company/employees/csv/
         * @secure
         */
        employeesCsv: (params: RequestParams = {}) =>
            this.request<File, any>({
                path: `/api/company/employees/csv/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Import employees from CSV (same schema as export).
         *
         * @tags Employees
         * @name EmployeesImportCsv
         * @summary Import employees from CSV
         * @request POST:/api/company/employees/import-csv/
         * @secure
         */
        employeesImportCsv: (
            data: {
                /** @format binary */
                file: File
            },
            params: RequestParams = {}
        ) =>
            this.request<EmployeeImportResponse, any>({
                path: `/api/company/employees/import-csv/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesMeRetrieve
         * @request GET:/api/company/employees/me/
         * @secure
         */
        companyEmployeesMeRetrieve: (params: RequestParams = {}) =>
            this.request<EmployeeMe, any>({
                path: `/api/company/employees/me/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags company
         * @name CompanyEmployeesMePartialUpdate
         * @request PATCH:/api/company/employees/me/
         * @secure
         */
        companyEmployeesMePartialUpdate: (data: PatchedEmployeeMeRequest, params: RequestParams = {}) =>
            this.request<EmployeeMe, any>({
                path: `/api/company/employees/me/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         *
         * @tags jwt
         * @name JwtCreateCreate
         * @request POST:/api/jwt/create/
         */
        jwtCreateCreate: (data: TokenObtainPairRequest, params: RequestParams = {}) =>
            this.request<TokenObtainPair, any>({
                path: `/api/jwt/create/`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         *
         * @tags jwt
         * @name JwtRefreshCreate
         * @request POST:/api/jwt/refresh/
         */
        jwtRefreshCreate: (data: TokenRefreshRequest, params: RequestParams = {}) =>
            this.request<TokenRefresh, any>({
                path: `/api/jwt/refresh/`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
         *
         * @tags jwt
         * @name JwtVerifyCreate
         * @request POST:/api/jwt/verify/
         */
        jwtVerifyCreate: (data: TokenVerifyRequest, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/jwt/verify/`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsList
         * @request GET:/api/schedule/day-kinds/
         * @secure
         */
        scheduleDayKindsList: (
            query?: {
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<DayKind[], any>({
                path: `/api/schedule/day-kinds/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsCreate
         * @request POST:/api/schedule/day-kinds/
         * @secure
         */
        scheduleDayKindsCreate: (data: DayKindRequest, params: RequestParams = {}) =>
            this.request<DayKind, any>({
                path: `/api/schedule/day-kinds/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsRetrieve
         * @request GET:/api/schedule/day-kinds/{id}/
         * @secure
         */
        scheduleDayKindsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<DayKind, any>({
                path: `/api/schedule/day-kinds/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsUpdate
         * @request PUT:/api/schedule/day-kinds/{id}/
         * @secure
         */
        scheduleDayKindsUpdate: (id: number, data: DayKindRequest, params: RequestParams = {}) =>
            this.request<DayKind, any>({
                path: `/api/schedule/day-kinds/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsPartialUpdate
         * @request PATCH:/api/schedule/day-kinds/{id}/
         * @secure
         */
        scheduleDayKindsPartialUpdate: (id: number, data: PatchedDayKindRequest, params: RequestParams = {}) =>
            this.request<DayKind, any>({
                path: `/api/schedule/day-kinds/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing day kinds (workday types, weekend types, etc.)
         *
         * @tags schedule
         * @name ScheduleDayKindsDestroy
         * @request DELETE:/api/schedule/day-kinds/{id}/
         * @secure
         */
        scheduleDayKindsDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/day-kinds/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysList
         * @request GET:/api/schedule/holidays/
         * @secure
         */
        scheduleHolidaysList: (
            query?: {
                autogenerated?: boolean
                /** @format date */
                date?: string
                /** @format date */
                date__gte?: string
                /** @format date */
                date__lte?: string
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<Holiday[], any>({
                path: `/api/schedule/holidays/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysCreate
         * @request POST:/api/schedule/holidays/
         * @secure
         */
        scheduleHolidaysCreate: (data: HolidayRequest, params: RequestParams = {}) =>
            this.request<Holiday, any>({
                path: `/api/schedule/holidays/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysRetrieve
         * @request GET:/api/schedule/holidays/{id}/
         * @secure
         */
        scheduleHolidaysRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<Holiday, any>({
                path: `/api/schedule/holidays/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysUpdate
         * @request PUT:/api/schedule/holidays/{id}/
         * @secure
         */
        scheduleHolidaysUpdate: (id: number, data: HolidayRequest, params: RequestParams = {}) =>
            this.request<Holiday, any>({
                path: `/api/schedule/holidays/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysPartialUpdate
         * @request PATCH:/api/schedule/holidays/{id}/
         * @secure
         */
        scheduleHolidaysPartialUpdate: (id: number, data: PatchedHolidayRequest, params: RequestParams = {}) =>
            this.request<Holiday, any>({
                path: `/api/schedule/holidays/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing public holidays. Visible to everyone; writes are manager/staff. The ``autogenerated`` flag is read-only and set exclusively by the sync. Additional endpoints: - POST /holidays/sync/ - Sync Japanese public holidays - GET /holidays/sync/preview/ - Preview sync without applying
         *
         * @tags schedule
         * @name ScheduleHolidaysDestroy
         * @request DELETE:/api/schedule/holidays/{id}/
         * @secure
         */
        scheduleHolidaysDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/holidays/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description Sync Japanese public holidays (内閣府 calendar). Replaces auto-generated entries for the given years (default: current and next). Staff-only.
         *
         * @tags schedule
         * @name ScheduleHolidaysSyncCreate
         * @request POST:/api/schedule/holidays/sync/
         * @secure
         */
        scheduleHolidaysSyncCreate: (data: HolidaySyncRequestRequest, params: RequestParams = {}) =>
            this.request<Record<string, any>, any>({
                path: `/api/schedule/holidays/sync/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Preview what a holiday sync would delete and create.
         *
         * @tags schedule
         * @name ScheduleHolidaysSyncPreviewRetrieve
         * @request GET:/api/schedule/holidays/sync/preview/
         * @secure
         */
        scheduleHolidaysSyncPreviewRetrieve: (
            query?: {
                years?: number[]
            },
            params: RequestParams = {}
        ) =>
            this.request<Record<string, any>, any>({
                path: `/api/schedule/holidays/sync/preview/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Read-only view over leave facts. Leaves are materialized by the vacation workflow; mutations go through the request (approve / cancel), never directly.
         *
         * @tags schedule
         * @name ScheduleLeavesList
         * @request GET:/api/schedule/leaves/
         * @secure
         */
        scheduleLeavesList: (
            query?: {
                employee?: number
                /** Multiple values may be separated by commas. */
                employee__in?: number[]
                /** @format date-time */
                ends_at?: string
                /** @format date-time */
                ends_at__gte?: string
                /** @format date-time */
                ends_at__lte?: string
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
                /** @format date-time */
                starts_at?: string
                /** @format date-time */
                starts_at__gte?: string
                /** @format date-time */
                starts_at__lte?: string
                /**
                 * Event status
                 *
                 * * `active` - Active
                 * * `cancelled` - Cancelled
                 */
                status?: 'active' | 'cancelled'
            },
            params: RequestParams = {}
        ) =>
            this.request<Leave[], any>({
                path: `/api/schedule/leaves/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Read-only view over leave facts. Leaves are materialized by the vacation workflow; mutations go through the request (approve / cancel), never directly.
         *
         * @tags schedule
         * @name ScheduleLeavesRetrieve
         * @request GET:/api/schedule/leaves/{id}/
         * @secure
         */
        scheduleLeavesRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<Leave, any>({
                path: `/api/schedule/leaves/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Per-day working and unscheduled counts for a month.
         *
         * @tags schedule
         * @name ScheduleRosterList
         * @request GET:/api/schedule/roster/
         * @secure
         */
        scheduleRosterList: (
            query: {
                /** Narrow to these branch IDs (comma-separated). */
                branch_ids__in?: number[]
                /**
                 * @min 1
                 * @max 12
                 */
                month: number
                /**
                 * @min 1
                 * @max 9999
                 */
                year: number
            },
            params: RequestParams = {}
        ) =>
            this.request<RosterDaySummary[], any>({
                path: `/api/schedule/roster/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Who works on a day with their planned hours, and who has no schedule for it.
         *
         * @tags schedule
         * @name ScheduleRosterDayRetrieve
         * @request GET:/api/schedule/roster/day/
         * @secure
         */
        scheduleRosterDayRetrieve: (
            query: {
                /** Narrow to these branch IDs (comma-separated). */
                branch_ids__in?: number[]
                /** @format date */
                date: string
            },
            params: RequestParams = {}
        ) =>
            this.request<RosterDay, any>({
                path: `/api/schedule/roster/day/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsList
         * @request GET:/api/schedule/schedule-exceptions/
         * @secure
         */
        scheduleScheduleExceptionsList: (
            query?: {
                day_kind?: number
                employee?: number
                /**
                 * Approved shifts are created by the overtime workflow; everything else is a schedule adjustment
                 *
                 * * `adjustment` - Schedule adjustment
                 * * `shift` - Approved shift
                 */
                kind?: 'adjustment' | 'shift'
                /** Which field to use when ordering the results. */
                ordering?: string
                schedule?: number
                /** A search term. */
                search?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<ScheduleException[], any>({
                path: `/api/schedule/schedule-exceptions/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsCreate
         * @request POST:/api/schedule/schedule-exceptions/
         * @secure
         */
        scheduleScheduleExceptionsCreate: (data: ScheduleExceptionRequest, params: RequestParams = {}) =>
            this.request<ScheduleException, any>({
                path: `/api/schedule/schedule-exceptions/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsRetrieve
         * @request GET:/api/schedule/schedule-exceptions/{id}/
         * @secure
         */
        scheduleScheduleExceptionsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<ScheduleException, any>({
                path: `/api/schedule/schedule-exceptions/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsUpdate
         * @request PUT:/api/schedule/schedule-exceptions/{id}/
         * @secure
         */
        scheduleScheduleExceptionsUpdate: (id: number, data: ScheduleExceptionRequest, params: RequestParams = {}) =>
            this.request<ScheduleException, any>({
                path: `/api/schedule/schedule-exceptions/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsPartialUpdate
         * @request PATCH:/api/schedule/schedule-exceptions/{id}/
         * @secure
         */
        scheduleScheduleExceptionsPartialUpdate: (
            id: number,
            data: PatchedScheduleExceptionRequest,
            params: RequestParams = {}
        ) =>
            this.request<ScheduleException, any>({
                path: `/api/schedule/schedule-exceptions/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing per-employee schedule exceptions.
         *
         * @tags schedule
         * @name ScheduleScheduleExceptionsDestroy
         * @request DELETE:/api/schedule/schedule-exceptions/{id}/
         * @secure
         */
        scheduleScheduleExceptionsDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/schedule-exceptions/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesList
         * @request GET:/api/schedule/schedules/
         * @secure
         */
        scheduleSchedulesList: (
            query?: {
                employee?: number
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
                year?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<Schedule[], any>({
                path: `/api/schedule/schedules/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesCreate
         * @request POST:/api/schedule/schedules/
         * @secure
         */
        scheduleSchedulesCreate: (data: ScheduleRequest, params: RequestParams = {}) =>
            this.request<Schedule, any>({
                path: `/api/schedule/schedules/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesRetrieve
         * @request GET:/api/schedule/schedules/{id}/
         * @secure
         */
        scheduleSchedulesRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<Schedule, any>({
                path: `/api/schedule/schedules/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesUpdate
         * @request PUT:/api/schedule/schedules/{id}/
         * @secure
         */
        scheduleSchedulesUpdate: (id: number, data: ScheduleRequest, params: RequestParams = {}) =>
            this.request<Schedule, any>({
                path: `/api/schedule/schedules/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesPartialUpdate
         * @request PATCH:/api/schedule/schedules/{id}/
         * @secure
         */
        scheduleSchedulesPartialUpdate: (id: number, data: PatchedScheduleRequest, params: RequestParams = {}) =>
            this.request<Schedule, any>({
                path: `/api/schedule/schedules/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing employee schedules
         *
         * @tags schedule
         * @name ScheduleSchedulesDestroy
         * @request DELETE:/api/schedule/schedules/{id}/
         * @secure
         */
        scheduleSchedulesDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/schedules/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsList
         * @request GET:/api/schedule/template-exceptions/
         * @secure
         */
        scheduleTemplateExceptionsList: (
            query?: {
                day_kind?: number
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
                year?: number
                year_template?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<TemplateException[], any>({
                path: `/api/schedule/template-exceptions/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsCreate
         * @request POST:/api/schedule/template-exceptions/
         * @secure
         */
        scheduleTemplateExceptionsCreate: (data: TemplateExceptionRequest, params: RequestParams = {}) =>
            this.request<TemplateException, any>({
                path: `/api/schedule/template-exceptions/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsRetrieve
         * @request GET:/api/schedule/template-exceptions/{id}/
         * @secure
         */
        scheduleTemplateExceptionsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<TemplateException, any>({
                path: `/api/schedule/template-exceptions/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsUpdate
         * @request PUT:/api/schedule/template-exceptions/{id}/
         * @secure
         */
        scheduleTemplateExceptionsUpdate: (id: number, data: TemplateExceptionRequest, params: RequestParams = {}) =>
            this.request<TemplateException, any>({
                path: `/api/schedule/template-exceptions/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsPartialUpdate
         * @request PATCH:/api/schedule/template-exceptions/{id}/
         * @secure
         */
        scheduleTemplateExceptionsPartialUpdate: (
            id: number,
            data: PatchedTemplateExceptionRequest,
            params: RequestParams = {}
        ) =>
            this.request<TemplateException, any>({
                path: `/api/schedule/template-exceptions/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing company-wide schedule exceptions attached to year templates (closures, shortened days, worked holidays).
         *
         * @tags schedule
         * @name ScheduleTemplateExceptionsDestroy
         * @request DELETE:/api/schedule/template-exceptions/{id}/
         * @secure
         */
        scheduleTemplateExceptionsDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/template-exceptions/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesList
         * @request GET:/api/schedule/year-templates/
         * @secure
         */
        scheduleYearTemplatesList: (
            query?: {
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
                year?: number
            },
            params: RequestParams = {}
        ) =>
            this.request<YearTemplate[], any>({
                path: `/api/schedule/year-templates/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesCreate
         * @request POST:/api/schedule/year-templates/
         * @secure
         */
        scheduleYearTemplatesCreate: (data: YearTemplateRequest, params: RequestParams = {}) =>
            this.request<YearTemplate, any>({
                path: `/api/schedule/year-templates/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesRetrieve
         * @request GET:/api/schedule/year-templates/{id}/
         * @secure
         */
        scheduleYearTemplatesRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<YearTemplate, any>({
                path: `/api/schedule/year-templates/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesUpdate
         * @request PUT:/api/schedule/year-templates/{id}/
         * @secure
         */
        scheduleYearTemplatesUpdate: (id: number, data: YearTemplateRequest, params: RequestParams = {}) =>
            this.request<YearTemplate, any>({
                path: `/api/schedule/year-templates/${id}/`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesPartialUpdate
         * @request PATCH:/api/schedule/year-templates/{id}/
         * @secure
         */
        scheduleYearTemplatesPartialUpdate: (id: number, data: PatchedYearTemplateRequest, params: RequestParams = {}) =>
            this.request<YearTemplate, any>({
                path: `/api/schedule/year-templates/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description ViewSet for managing year templates (yearly schedule definitions)
         *
         * @tags schedule
         * @name ScheduleYearTemplatesDestroy
         * @request DELETE:/api/schedule/year-templates/{id}/
         * @secure
         */
        scheduleYearTemplatesDestroy: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/schedule/year-templates/${id}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name TasEventsList
         * @request GET:/api/tas/events/
         * @secure
         */
        tasEventsList: (
            query?: {
                id?: number
                /** Multiple values may be separated by commas. */
                id__in?: number[]
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** @format date */
                record_range_after?: string
                /** @format date */
                record_range_before?: string
                /** @format date-time */
                recorded_at?: string
                /** @format date-time */
                recorded_at__gte?: string
                /** @format date-time */
                recorded_at__lte?: string
                /** A search term. */
                search?: string
                workday?: number
                workday__employee?: number
                /** Multiple values may be separated by commas. */
                workday__employee__in?: number[]
                /** Multiple values may be separated by commas. */
                workday__in?: number[]
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedWorkEventOutputList, any>({
                path: `/api/tas/events/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name TasEventsCreate
         * @request POST:/api/tas/events/
         * @secure
         */
        tasEventsCreate: (data: WorkEventCreateInputRequest, params: RequestParams = {}) =>
            this.request<WorkEventOutput, any>({
                path: `/api/tas/events/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name TasEventsRetrieve
         * @request GET:/api/tas/events/{id}/
         * @secure
         */
        tasEventsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<WorkEventOutput, any>({
                path: `/api/tas/events/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name TasEventsPartialUpdate
         * @request PATCH:/api/tas/events/{id}/
         * @secure
         */
        tasEventsPartialUpdate: (id: number, data: PatchedWorkEventOutputRequest, params: RequestParams = {}) =>
            this.request<WorkEventOutput, any>({
                path: `/api/tas/events/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Returns employees with their events grouped as in/out pairs for a specific day. Pagination is by employees.
         *
         * @tags tas
         * @name EventsGrouped
         * @request GET:/api/tas/events/grouped/
         * @secure
         */
        eventsGrouped: (
            query?: {
                /** Filter events by single branch ID. */
                branch_id?: number
                /** Comma-separated branch IDs to filter by (e.g. 98,100). */
                branch_ids__in?: number[]
                /** Filter employees by scheduled-workday status. Checks against record_range_after/record_range_before if provided, otherwise current moment. Omit for no filtering. */
                is_shifted?: boolean | null
                /** Page number (1-based). Defaults to 1. */
                page?: number
                /** Number of employees per page. Defaults to 20, max 100. */
                page_size?: number
                /**
                 * Range start (ISO 8601) for the is_shifted check.
                 * @format date-time
                 */
                record_range_after?: string
                /**
                 * Range end (ISO 8601) for the is_shifted check.
                 * @format date-time
                 */
                record_range_before?: string
                /**
                 * Date to filter events (YYYY-MM-DD). Defaults to today. Ignored when recorded_at__gte/lte provided.
                 * @format date
                 */
                recorded_at?: string
                /**
                 * Lower bound for event recorded_at (ISO 8601 datetime).
                 * @format date-time
                 */
                recorded_at__gte?: string
                /**
                 * Upper bound for event recorded_at (ISO 8601 datetime).
                 * @format date-time
                 */
                recorded_at__lte?: string
                /**
                 * Search employees by name or ID (depending on searchKey).
                 * @minLength 1
                 */
                search?: string
                /** Search fields (multiple allowed). Defaults to ['name', 'name_kana']. */
                searchKey?: ('name' | 'name_kana' | 'id' | 'employee_code')[]
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedEmployeeEventsResponse, any>({
                path: `/api/tas/events/grouped/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Export grouped events as CSV with same filters as grouped action.
         *
         * @tags Work Events
         * @name EventsGroupedCsv
         * @summary Export grouped events as CSV
         * @request GET:/api/tas/events/grouped-csv/
         * @secure
         */
        eventsGroupedCsv: (
            query?: {
                /** Filter events by single branch ID. */
                branch_id?: number
                /** Comma-separated branch IDs to filter by (e.g. 98,100). */
                branch_ids__in?: number[]
                /** Filter employees by scheduled-workday status. Checks against record_range_after/record_range_before if provided, otherwise current moment. Omit for no filtering. */
                is_shifted?: boolean | null
                /**
                 * Range start (ISO 8601) for the is_shifted check.
                 * @format date-time
                 */
                record_range_after?: string
                /**
                 * Range end (ISO 8601) for the is_shifted check.
                 * @format date-time
                 */
                record_range_before?: string
                /**
                 * Date to filter events (YYYY-MM-DD). Defaults to today. Ignored when recorded_at__gte/lte provided.
                 * @format date
                 */
                recorded_at?: string
                /**
                 * Lower bound for event recorded_at (ISO 8601 datetime).
                 * @format date-time
                 */
                recorded_at__gte?: string
                /**
                 * Upper bound for event recorded_at (ISO 8601 datetime).
                 * @format date-time
                 */
                recorded_at__lte?: string
                /**
                 * Search employees by name or ID (depending on searchKey).
                 * @minLength 1
                 */
                search?: string
                /** Search fields (multiple allowed). Defaults to ['name', 'name_kana']. */
                searchKey?: ('name' | 'name_kana' | 'id' | 'employee_code')[]
            },
            params: RequestParams = {}
        ) =>
            this.request<File, any>({
                path: `/api/tas/events/grouped-csv/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Returns grouped events for a specific employee on a specific day.
         *
         * @tags tas
         * @name EventsGroupedByEmployee
         * @request GET:/api/tas/events/grouped/{employee_id}/
         * @secure
         */
        eventsGroupedByEmployee: (
            employeeId: number,
            query?: {
                /** Filter events by single branch ID. */
                branch_id?: number
                /** Filter events by multiple branch IDs (comma-separated, e.g. 98,100). */
                branch_ids__in?: number[]
                /**
                 * Date to filter events (YYYY-MM-DD). Defaults to today.
                 * @format date
                 */
                recorded_at?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EmployeeEvents, any>({
                path: `/api/tas/events/grouped/${employeeId}/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name EventsIngest
         * @request POST:/api/tas/events/ingest/
         * @secure
         */
        eventsIngest: (data: WorkEventCreateInputRequest[], params: RequestParams = {}) =>
            this.request<WorkEventIngestOutput, any>({
                path: `/api/tas/events/ingest/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description CRUD for WorkEvent model. Update is available to managers only
         *
         * @tags tas
         * @name TasEventsPollRetrieve
         * @summary Poll for WorkEvent changes
         * @request GET:/api/tas/events/poll/
         * @secure
         */
        tasEventsPollRetrieve: (
            query: {
                /** ISO 8601 datetime. Returns change info after this timestamp. */
                since: string
            },
            params: RequestParams = {}
        ) =>
            this.request<WorkEventPollResponse, any>({
                path: `/api/tas/events/poll/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Basic CRUD for Workday. Only the details field can be updated from the API. Use events endpoint for linking events with this object.
         *
         * @tags tas
         * @name TasWorkdaysList
         * @request GET:/api/tas/workdays/
         * @secure
         */
        tasWorkdaysList: (
            query?: {
                ad_hoc?: boolean
                approved?: boolean
                /** Multiple values may be separated by commas. */
                approved__in?: boolean[]
                /** @format date */
                date?: string
                /** @format date */
                date_range_after?: string
                /** @format date */
                date_range_before?: string
                employee?: number
                /** Multiple values may be separated by commas. */
                employee__in?: number[]
                id?: number
                /** Multiple values may be separated by commas. */
                id__in?: number[]
                inconsistent?: boolean
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A search term. */
                search?: string
                /**
                 * Workday status, not to be confused with accounting status.
                 *
                 * * `new` - New
                 * * `working` - Working
                 * * `finished` - Finished
                 */
                status?: 'finished' | 'new' | 'working'
                /** Multiple values may be separated by commas. */
                status__in?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<WorkdayWithEmployee[], any>({
                path: `/api/tas/workdays/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Basic CRUD for Workday. Only the details field can be updated from the API. Use events endpoint for linking events with this object.
         *
         * @tags tas
         * @name TasWorkdaysRetrieve
         * @request GET:/api/tas/workdays/{id}/
         * @secure
         */
        tasWorkdaysRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<WorkdayWithEmployee, any>({
                path: `/api/tas/workdays/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Basic CRUD for Workday. Only the details field can be updated from the API. Use events endpoint for linking events with this object.
         *
         * @tags tas
         * @name TasWorkdaysPartialUpdate
         * @request PATCH:/api/tas/workdays/{id}/
         * @secure
         */
        tasWorkdaysPartialUpdate: (id: number, data: PatchedWorkdayWithEmployeeRequest, params: RequestParams = {}) =>
            this.request<WorkdayWithEmployee, any>({
                path: `/api/tas/workdays/${id}/`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Balance summary per leave type (all non-zero types, plus paid). Empty when the employee has no ledger, i.e. the balance was never set up.
         *
         * @tags Leave balance
         * @name WorkflowEmployeesLeaveBalanceList
         * @request GET:/api/workflow/employees/{employee_pk}/leave-balance/
         * @secure
         */
        workflowEmployeesLeaveBalanceList: (
            employeePk: number,
            query?: {
                /** Filter by leave type */
                leave_type?:
                    | 'bereavement'
                    | 'compensatory'
                    | 'family_care'
                    | 'maternity'
                    | 'other'
                    | 'paid'
                    | 'parental'
                    | 'sick'
                    | 'study'
                    | 'unpaid'
            },
            params: RequestParams = {}
        ) =>
            this.request<LeaveBalance[], any>({
                path: `/api/workflow/employees/${employeePk}/leave-balance/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Ledger history for an employee.
         *
         * @tags Leave balance
         * @name WorkflowEmployeesLeaveBalanceHistoryList
         * @request GET:/api/workflow/employees/{employee_pk}/leave-balance/history/
         * @secure
         */
        workflowEmployeesLeaveBalanceHistoryList: (employeePk: number, params: RequestParams = {}) =>
            this.request<LeaveBalanceLedger[], any>({
                path: `/api/workflow/employees/${employeePk}/leave-balance/history/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Seed initial used days (usage entry) for system migration.
         *
         * @tags Leave balance
         * @name WorkflowEmployeesLeaveBalanceSeedCreate
         * @request POST:/api/workflow/employees/{employee_pk}/leave-balance/seed/
         * @secure
         */
        workflowEmployeesLeaveBalanceSeedCreate: (
            employeePk: number,
            data: LeaveBalanceSeedRequestRequest,
            params: RequestParams = {}
        ) =>
            this.request<LeaveBalanceLedger, any>({
                path: `/api/workflow/employees/${employeePk}/leave-balance/seed/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Retroactive clock-in/out requests with approve/reject workflow.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsList
         * @request GET:/api/workflow/event-requests/
         * @secure
         */
        workflowEventRequestsList: (
            query?: {
                /** @format date */
                date_from?: string
                /** @format date */
                date_to?: string
                employee?: number
                event_kind?: string
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** A search term. */
                search?: string
                /**
                 * * `pending` - Pending
                 * * `approved` - Approved
                 * * `rejected` - Rejected
                 * * `cancelled` - Cancelled
                 */
                status?: 'approved' | 'cancelled' | 'pending' | 'rejected'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedEventRequestListList, any>({
                path: `/api/workflow/event-requests/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Retroactive clock-in/out requests with approve/reject workflow.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsCreate
         * @request POST:/api/workflow/event-requests/
         * @secure
         */
        workflowEventRequestsCreate: (data: EventRequestRequest, params: RequestParams = {}) =>
            this.request<EventRequest, any>({
                path: `/api/workflow/event-requests/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Retroactive clock-in/out requests with approve/reject workflow.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsRetrieve
         * @request GET:/api/workflow/event-requests/{id}/
         * @secure
         */
        workflowEventRequestsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<EventRequest, any>({
                path: `/api/workflow/event-requests/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Approve and materialize the WorkEvent. Reviewer-only.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsApproveCreate
         * @request POST:/api/workflow/event-requests/{id}/approve/
         * @secure
         */
        workflowEventRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
            this.request<EventRequest, any>({
                path: `/api/workflow/event-requests/${id}/approve/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Cancel the request. Requester or staff only.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsCancelCreate
         * @request POST:/api/workflow/event-requests/{id}/cancel/
         * @secure
         */
        workflowEventRequestsCancelCreate: (id: number, params: RequestParams = {}) =>
            this.request<EventRequest, any>({
                path: `/api/workflow/event-requests/${id}/cancel/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Reject the request with a reason. Reviewer-only.
         *
         * @tags Event requests
         * @name WorkflowEventRequestsRejectCreate
         * @request POST:/api/workflow/event-requests/{id}/reject/
         * @secure
         */
        workflowEventRequestsRejectCreate: (id: number, data: RejectReasonRequest, params: RequestParams = {}) =>
            this.request<EventRequest, any>({
                path: `/api/workflow/event-requests/${id}/reject/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Expense requests with approve/reject workflow and receipts. No update/destroy: DELETE is only for the receipts sub-route.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsList
         * @request GET:/api/workflow/expense-requests/
         * @secure
         */
        workflowExpenseRequestsList: (
            query?: {
                category?: string
                /** @format date */
                date_from?: string
                /** @format date */
                date_to?: string
                employee?: number
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** A search term. */
                search?: string
                /**
                 * * `pending` - Pending
                 * * `approved` - Approved
                 * * `rejected` - Rejected
                 * * `cancelled` - Cancelled
                 */
                status?: 'approved' | 'cancelled' | 'pending' | 'rejected'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedExpenseRequestListList, any>({
                path: `/api/workflow/expense-requests/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Expense requests with approve/reject workflow and receipts. No update/destroy: DELETE is only for the receipts sub-route.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsCreate
         * @request POST:/api/workflow/expense-requests/
         * @secure
         */
        workflowExpenseRequestsCreate: (data: ExpenseRequestRequest, params: RequestParams = {}) =>
            this.request<ExpenseRequest, any>({
                path: `/api/workflow/expense-requests/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Expense requests with approve/reject workflow and receipts. No update/destroy: DELETE is only for the receipts sub-route.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsRetrieve
         * @request GET:/api/workflow/expense-requests/{id}/
         * @secure
         */
        workflowExpenseRequestsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<ExpenseRequest, any>({
                path: `/api/workflow/expense-requests/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Approve the request. Reviewer-only.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsApproveCreate
         * @request POST:/api/workflow/expense-requests/{id}/approve/
         * @secure
         */
        workflowExpenseRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
            this.request<ExpenseRequest, any>({
                path: `/api/workflow/expense-requests/${id}/approve/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Cancel the request. Requester or staff only.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsCancelCreate
         * @request POST:/api/workflow/expense-requests/{id}/cancel/
         * @secure
         */
        workflowExpenseRequestsCancelCreate: (id: number, params: RequestParams = {}) =>
            this.request<ExpenseRequest, any>({
                path: `/api/workflow/expense-requests/${id}/cancel/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Attach a receipt (image or PDF) to a pending expense request.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsReceiptsCreate
         * @request POST:/api/workflow/expense-requests/{id}/receipts/
         * @secure
         */
        workflowExpenseRequestsReceiptsCreate: (id: number, data: ExpenseReceiptUploadRequest, params: RequestParams = {}) =>
            this.request<ExpenseReceipt, any>({
                path: `/api/workflow/expense-requests/${id}/receipts/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * @description Delete a receipt from a pending expense request.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsReceiptsDestroy
         * @request DELETE:/api/workflow/expense-requests/{id}/receipts/{receipt_id}/
         * @secure
         */
        workflowExpenseRequestsReceiptsDestroy: (id: number, receiptId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/workflow/expense-requests/${id}/receipts/${receiptId}/`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description Reject the request with a reason. Reviewer-only.
         *
         * @tags Expense requests
         * @name WorkflowExpenseRequestsRejectCreate
         * @request POST:/api/workflow/expense-requests/{id}/reject/
         * @secure
         */
        workflowExpenseRequestsRejectCreate: (id: number, data: RejectReasonRequest, params: RequestParams = {}) =>
            this.request<ExpenseRequest, any>({
                path: `/api/workflow/expense-requests/${id}/reject/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Import leave balance from CSV. Columns: Employee code, Leave type, Amount, Effective date, Comment. Amount: positive = accrual/adjustment, negative = used days.
         *
         * @tags Leave balance
         * @name WorkflowLeaveBalanceImportCsvCreate
         * @summary Bulk import leave balance adjustments from CSV
         * @request POST:/api/workflow/leave-balance/import-csv/
         * @secure
         */
        workflowLeaveBalanceImportCsvCreate: (
            data: {
                /** @format binary */
                file: File
            },
            query?: {
                /**
                 * Language of CSV column headers. `en`: Employee code, Leave type, Amount, Effective date, Comment. `ja`: 社員コード, 休暇種別, 日数, 適用日, 備考.
                 * @default "en"
                 */
                lang?: 'en' | 'ja'
            },
            params: RequestParams = {}
        ) =>
            this.request<
                {
                    created?: number
                    skipped?: object[]
                    errors?: object[]
                },
                any
            >({
                path: `/api/workflow/leave-balance/import-csv/`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * @description Download sample CSV for leave balance import.
         *
         * @tags Leave balance
         * @name WorkflowLeaveBalanceSampleCsvRetrieve
         * @summary Download sample CSV for leave balance import
         * @request GET:/api/workflow/leave-balance/sample-csv/
         * @secure
         */
        workflowLeaveBalanceSampleCsvRetrieve: (
            query?: {
                /**
                 * Language of CSV column headers. `en`: Employee code, Leave type, Amount, Effective date, Comment. `ja`: 社員コード, 休暇種別, 日数, 適用日, 備考.
                 * @default "en"
                 */
                lang?: 'en' | 'ja'
            },
            params: RequestParams = {}
        ) =>
            this.request<File, any>({
                path: `/api/workflow/leave-balance/sample-csv/`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * @description Overtime requests with approve/reject workflow. No update/destroy: a wrong request is cancelled and filed again.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsList
         * @request GET:/api/workflow/overtime-requests/
         * @secure
         */
        workflowOvertimeRequestsList: (
            query?: {
                /** @format date */
                date_from?: string
                /** @format date */
                date_to?: string
                employee?: number
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** A search term. */
                search?: string
                /**
                 * * `pending` - Pending
                 * * `approved` - Approved
                 * * `rejected` - Rejected
                 * * `cancelled` - Cancelled
                 */
                status?: 'approved' | 'cancelled' | 'pending' | 'rejected'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedOvertimeRequestListList, any>({
                path: `/api/workflow/overtime-requests/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Overtime requests with approve/reject workflow. No update/destroy: a wrong request is cancelled and filed again.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsCreate
         * @request POST:/api/workflow/overtime-requests/
         * @secure
         */
        workflowOvertimeRequestsCreate: (data: OvertimeRequestRequest, params: RequestParams = {}) =>
            this.request<OvertimeRequest, any>({
                path: `/api/workflow/overtime-requests/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Overtime requests with approve/reject workflow. No update/destroy: a wrong request is cancelled and filed again.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsRetrieve
         * @request GET:/api/workflow/overtime-requests/{id}/
         * @secure
         */
        workflowOvertimeRequestsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<OvertimeRequest, any>({
                path: `/api/workflow/overtime-requests/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Approve the request and materialize the approved shift into the schedule (or directly into an already stamped workday). Reviewer-only.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsApproveCreate
         * @request POST:/api/workflow/overtime-requests/{id}/approve/
         * @secure
         */
        workflowOvertimeRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
            this.request<OvertimeRequest, any>({
                path: `/api/workflow/overtime-requests/${id}/approve/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Cancel the request. Requester or staff only.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsCancelCreate
         * @request POST:/api/workflow/overtime-requests/{id}/cancel/
         * @secure
         */
        workflowOvertimeRequestsCancelCreate: (id: number, params: RequestParams = {}) =>
            this.request<OvertimeRequest, any>({
                path: `/api/workflow/overtime-requests/${id}/cancel/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Reject the request with a reason. Reviewer-only.
         *
         * @tags Overtime requests
         * @name WorkflowOvertimeRequestsRejectCreate
         * @request POST:/api/workflow/overtime-requests/{id}/reject/
         * @secure
         */
        workflowOvertimeRequestsRejectCreate: (id: number, data: RejectReasonRequest, params: RequestParams = {}) =>
            this.request<OvertimeRequest, any>({
                path: `/api/workflow/overtime-requests/${id}/reject/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Vacation request CRUD with approve/reject/cancel workflow.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsList
         * @request GET:/api/workflow/vacation-requests/
         * @secure
         */
        workflowVacationRequestsList: (
            query?: {
                /** @format date */
                date_from?: string
                /** @format date */
                date_to?: string
                employee?: number
                /** Which field to use when ordering the results. */
                ordering?: string
                /** A page number within the paginated result set. */
                page?: number
                /** Number of results to return per page. */
                page_size?: number
                /** A search term. */
                search?: string
                /**
                 * * `pending` - Pending
                 * * `approved` - Approved
                 * * `rejected` - Rejected
                 * * `cancelled` - Cancelled
                 */
                status?: 'approved' | 'cancelled' | 'pending' | 'rejected'
            },
            params: RequestParams = {}
        ) =>
            this.request<PaginatedVacationRequestListList, any>({
                path: `/api/workflow/vacation-requests/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Vacation request CRUD with approve/reject/cancel workflow.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsCreate
         * @request POST:/api/workflow/vacation-requests/
         * @secure
         */
        workflowVacationRequestsCreate: (data: VacationRequestRequest, params: RequestParams = {}) =>
            this.request<VacationRequest, any>({
                path: `/api/workflow/vacation-requests/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            }),

        /**
         * @description Vacation request CRUD with approve/reject/cancel workflow.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsRetrieve
         * @request GET:/api/workflow/vacation-requests/{id}/
         * @secure
         */
        workflowVacationRequestsRetrieve: (id: number, params: RequestParams = {}) =>
            this.request<VacationRequest, any>({
                path: `/api/workflow/vacation-requests/${id}/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Approve the request. Reviewer-only.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsApproveCreate
         * @request POST:/api/workflow/vacation-requests/{id}/approve/
         * @secure
         */
        workflowVacationRequestsApproveCreate: (id: number, params: RequestParams = {}) =>
            this.request<VacationRequest, any>({
                path: `/api/workflow/vacation-requests/${id}/approve/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Cancel the request. Requester or staff only.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsCancelCreate
         * @request POST:/api/workflow/vacation-requests/{id}/cancel/
         * @secure
         */
        workflowVacationRequestsCancelCreate: (id: number, params: RequestParams = {}) =>
            this.request<VacationRequest, any>({
                path: `/api/workflow/vacation-requests/${id}/cancel/`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params
            }),

        /**
         * @description Reject the request with a reason. Reviewer-only.
         *
         * @tags Vacation requests
         * @name WorkflowVacationRequestsRejectCreate
         * @request POST:/api/workflow/vacation-requests/{id}/reject/
         * @secure
         */
        workflowVacationRequestsRejectCreate: (id: number, data: RejectReasonRequest, params: RequestParams = {}) =>
            this.request<VacationRequest, any>({
                path: `/api/workflow/vacation-requests/${id}/reject/`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params
            })
    }
    check = {
        /**
         * No description
         *
         * @tags internal
         * @name CheckRetrieve
         * @summary Health check
         * @request GET:/check/
         * @secure
         */
        checkRetrieve: (params: RequestParams = {}) =>
            this.request<
                {
                    /** @example "ok" */
                    status?: string
                },
                any
            >({
                path: `/check/`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params
            })
    }
    schema = {
        /**
         * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         *
         * @tags schema
         * @name SchemaRetrieve
         * @request GET:/schema/
         * @secure
         */
        schemaRetrieve: (
            query?: {
                format?: 'json' | 'yaml'
                lang?:
                    | 'af'
                    | 'ar'
                    | 'ar-dz'
                    | 'ast'
                    | 'az'
                    | 'be'
                    | 'bg'
                    | 'bn'
                    | 'br'
                    | 'bs'
                    | 'ca'
                    | 'ckb'
                    | 'cs'
                    | 'cy'
                    | 'da'
                    | 'de'
                    | 'dsb'
                    | 'el'
                    | 'en'
                    | 'en-au'
                    | 'en-gb'
                    | 'eo'
                    | 'es'
                    | 'es-ar'
                    | 'es-co'
                    | 'es-mx'
                    | 'es-ni'
                    | 'es-ve'
                    | 'et'
                    | 'eu'
                    | 'fa'
                    | 'fi'
                    | 'fr'
                    | 'fy'
                    | 'ga'
                    | 'gd'
                    | 'gl'
                    | 'he'
                    | 'hi'
                    | 'hr'
                    | 'hsb'
                    | 'hu'
                    | 'hy'
                    | 'ia'
                    | 'id'
                    | 'ig'
                    | 'io'
                    | 'is'
                    | 'it'
                    | 'ja'
                    | 'ka'
                    | 'kab'
                    | 'kk'
                    | 'km'
                    | 'kn'
                    | 'ko'
                    | 'ky'
                    | 'lb'
                    | 'lt'
                    | 'lv'
                    | 'mk'
                    | 'ml'
                    | 'mn'
                    | 'mr'
                    | 'ms'
                    | 'my'
                    | 'nb'
                    | 'ne'
                    | 'nl'
                    | 'nn'
                    | 'os'
                    | 'pa'
                    | 'pl'
                    | 'pt'
                    | 'pt-br'
                    | 'ro'
                    | 'ru'
                    | 'sk'
                    | 'sl'
                    | 'sq'
                    | 'sr'
                    | 'sr-latn'
                    | 'sv'
                    | 'sw'
                    | 'ta'
                    | 'te'
                    | 'tg'
                    | 'th'
                    | 'tk'
                    | 'tr'
                    | 'tt'
                    | 'udm'
                    | 'ug'
                    | 'uk'
                    | 'ur'
                    | 'uz'
                    | 'vi'
                    | 'zh-hans'
                    | 'zh-hant'
            },
            params: RequestParams = {}
        ) =>
            this.request<Record<string, any>, any>({
                path: `/schema/`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params
            })
    }
}
